<style scoped>
.view-parts-button {
  margin: 0;
  font-size: 0.75rem;
  font-weight: 700;
}
.parts-modal {
  overflow: hidden;
}
.parts-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  color: #fff;
  background: #43414c;
}
.parts-modal__eyebrow {
  margin-bottom: 0.25rem;
  font-size: 0.75rem;
  opacity: 0.8;
}
.parts-modal__title {
  font-size: 1.125rem;
  font-weight: 500;
  line-height: 1.3;
}
.parts-modal__actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.parts-modal__body {
  padding: 0 !important;
}
.parts-modal__footer {
  padding: 1rem 1.5rem;
  border-top: 1px solid #e4e4e4;
}
.parts-modal__sold-separately {
  margin: 1.25rem 1.5rem 0;
  color: #0c7258;
  font-size: 0.875rem;
  font-weight: 700;
}
.parts-modal__showing {
  margin: 0.5rem 1.5rem 0;
  color: #333;
  font-size: 0.875rem;
  font-weight: 600;
}
.parts-modal__error {
  margin: 0 1.5rem 1.25rem;
  color: #b71c1c;
  font-size: 0.875rem;
  font-weight: 600;
}
.parts-modal__content {
  display: grid;
  grid-template-columns: minmax(220px, 0.9fr) minmax(360px, 1.1fr);
  gap: 1.5rem;
  padding: 1.5rem;
}
.parts-modal__preview {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 340px;
  background: #f4f1f1;
}
.parts-modal__preview img {
  display: block;
  width: 100%;
  height: 340px;
  object-fit: contain;
}
.parts-modal__table-wrap {
  overflow: auto;
  max-height: 340px;
  border: 1px solid #dedede;
}
.parts-table {
  width: 100%;
  border-collapse: collapse;
}
.parts-table th,
.parts-table td {
  padding: 0.85rem;
  border-bottom: 1px solid #e4e4e4;
  text-align: left;
}
.parts-table th {
  color: #333;
  background: #f4f4f4;
  font-size: 0.75rem;
  font-weight: 700;
}
.parts-table td:last-child {
  color: #632a38;
  font-weight: 700;
  white-space: nowrap;
}
.parts-table tbody tr {
  cursor: pointer;
}
.parts-table tbody tr:hover,
.parts-table__row--selected {
  background: #f7f4f4;
  box-shadow: inset 4px 0 #d9313e;
}
.parts-table td:first-child {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.parts-table__thumbnail {
  width: 40px;
  height: 40px;
  object-fit: cover;
}
.parts-table .v-text-field {
  min-width: 0;
  margin: 0;
}
@media (max-width: 600px) {
  .parts-modal__content {
    grid-template-columns: 1fr;
    padding: 1rem;
  }
  .parts-modal__preview,
  .parts-modal__preview img {
    min-height: 200px;
    height: 200px;
  }
}

.pdp-page {
  max-width: 1200px;
  margin: 0 auto;
}
/* Align with app layout: v-app-bar + .v-main padding-top (TheNavBar / App.vue) */
.pdp-toolbar-sticky {
  position: sticky;
  top: 5rem;
  z-index: 4;
  background: #fff;
  /* Match .variants-card frame */
  border: 1px solid #d0d0d0;
  border-radius: 8px;
  /* Mirror space below buttons: padding-bottom + margin-bottom */
  padding-top: 12px;
  padding-bottom: 12px;
  margin-bottom: 0.75rem;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
}
@media (max-width: 800px) {
  .pdp-toolbar-sticky {
    top: 4rem;
  }
}
.pdp-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-left: 12px;
  padding-right: 12px;
  margin-bottom: 0;
  width: 100%;
}
.pdp-toolbar-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}
/* Dirty state: tint only the outlined input surface (not whole layout cells) */
.pdp-input--dirty >>> .v-input__slot {
  background-color: rgba(25, 118, 210, 0.08) !important;
}
.recent-mod-banner {
  border-radius: 4px;
}
.unpublish-snackbar >>> .v-snack__content {
  font-size: 1.05rem;
  line-height: 1.45;
}
.unpublish-confirm-card {
  overflow: visible;
  padding-top: 6px;
  padding-left: 6px;
}
.edit-support-footer {
  margin-top: 1.5rem;
  padding: 1.5rem 1.25rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fafafa;
}
.edit-support-footer__title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 0.35rem 0;
}
.edit-support-footer__sub {
  font-size: 0.875rem;
  color: #616161;
  margin: 0 0 1rem 0;
  line-height: 1.45;
}
.variants-table tbody td.desc-col {
  overflow-x: hidden;
  overflow-y: visible;
}
/* Product summary — mirrors PDP summary + summaryDetails structure */
.pdp-summary {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 1.75rem 2.25rem;
  margin-bottom: 2.5rem;
}
.pdp-summary-media {
  flex-shrink: 0;
  min-width: 0;
}
.pdp-main-media {
  min-width: 0;
}
.pdp-main-image-wrap {
  line-height: 0;
}
.pdp-main-image {
  max-width: 330px;
  width: 100%;
  height: auto;
  display: block;
  color: transparent;
}
.pdp-main-placeholder {
  max-width: 330px;
  min-height: 200px;
  padding: 1rem;
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.pdp-summary-details {
  flex: 1;
  min-width: min(100%, 280px);
  max-width: 640px;
}
.pdp-h1 {
  font-size: clamp(1.375rem, 2.5vw, 1.75rem);
  font-weight: 700;
  line-height: 1.2;
  color: #1a1a1a;
  letter-spacing: -0.02em;
  margin: 0;
  padding: 0;
}
/* Title / subtitle: same outlined treatment as composer & spec fields */
.pdp-title-field {
  max-width: 640px;
}
.pdp-title-field >>> .v-input__slot {
  min-height: 44px !important;
}
.pdp-title-field >>> input {
  font-size: clamp(1.25rem, 2.4vw, 1.65rem) !important;
  font-weight: 700 !important;
  line-height: 1.25 !important;
  color: #1a1a1a !important;
}
.pdp-subtitle-field {
  max-width: 640px;
  margin-top: 0.5rem !important;
}
.pdp-subtitle-field >>> .v-input__slot {
  min-height: 36px !important;
}
.pdp-subtitle-field >>> input {
  font-size: 0.9375rem !important;
  color: #424242 !important;
}
.pdp-h2 {
  font-size: 0.9375rem;
  font-weight: 400;
  line-height: 1.4;
  color: #424242;
  margin: 0.5rem 0 0 0;
  padding: 0;
}
.pdp-details-container {
  margin-top: 0.75rem;
}
.pdp-credit-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 12px;
  row-gap: 8px;
  max-width: 640px;
}
.pdp-credit-row + .pdp-credit-row {
  margin-top: 0.5rem;
}
.pdp-spec {
  font-size: 0.9375rem;
  line-height: 1.5;
  color: #333;
  margin: 0 0 0.25rem 0;
}
.pdp-spec-field {
  max-width: 420px;
}
.pdp-spec-field >>> .v-input__slot {
  min-height: 36px !important;
}
.pdp-description {
  font-size: 0.9375rem;
  line-height: 1.55;
  color: #333;
  margin-top: 1.25rem;
}
.pdp-description-field,
.pdp-description-locked-wrap {
  max-width: 640px;
}
.pdp-description-locked-wrap {
  cursor: default;
}
/* SKU list (PLP-style) */
.variants-card {
  border: 1px solid #d0d0d0;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}
/* Horizontal scroll on narrow viewports — columns keep min widths; no overlap. */
.variants-table-scroll {
  overflow-x: auto;
  overflow-y: visible;
  width: 100%;
  max-width: 100%;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-x: contain;
}
.variants-table {
  width: 100%;
  min-width: 1040px;
  border-collapse: collapse;
  font-size: 0.875rem;
  table-layout: fixed;
}
.variants-table col.variants-col-ids {
  width: 17%;
}
.variants-table col.variants-col-desc {
  width: 28%;
}
.variants-table col.variants-col-level {
  width: 18%;
}
.variants-table col.variants-col-preview {
  width: 8%;
}
.variants-table col.variants-col-parts {
  width: 8%;
}
.variants-table col.variants-col-price {
  width: 10%;
}
.variants-table col.variants-col-qty {
  width: 11%;
}
.variants-table col.variants-col-active {
  width: 6%;
}
.variants-table col.variants-col-unpublish {
  width: 5%;
}
.variants-table thead th {
  text-align: left;
  vertical-align: middle;
  padding: 12px;
  background: #f3f3f3;
  border-bottom: 1px solid #d0d0d0;
  font-weight: 600;
  color: #333;
  font-size: 0.8125rem;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  line-height: 1.35;
}
.variants-table tbody td {
  padding: 12px;
  vertical-align: middle;
  border-bottom: 1px solid #e5e5e5;
}
.variants-table thead th.desc-col,
.variants-table tbody td.desc-col {
  vertical-align: top;
}
.variants-table thead th.ids-col,
.variants-table thead th.level-col,
.variants-table thead th.preview-col,
.variants-table thead th.price-col,
.variants-table thead th.qty-col,
.variants-table thead th.active-col,
.variants-table thead th.unpublish-col {
  vertical-align: top;
}
.variants-table tbody td.ids-cell,
.variants-table tbody td.level-cell,
.variants-table tbody td.preview-cell,
.variants-table tbody td.parts-cell,
.variants-table tbody td.price-cell,
.variants-table tbody td.qty-cell,
.variants-table tbody td.active-cell,
.variants-table tbody td.unpublish-cell {
  vertical-align: top;
  word-break: break-word;
}
.unpublish-cell {
  text-align: center;
}
.parts-cell {
  text-align: center;
}
.preview-cell-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  padding-top: 2px;
}
.preview-video-btn {
  min-width: 0 !important;
  height: auto !important;
  padding: 4px 6px !important;
}
.preview-video-label {
  font-size: 0.6875rem;
  line-height: 1.2;
  margin-top: 2px;
  color: rgba(0, 0, 0, 0.6);
}
.preview-video-btn--muted .preview-video-label {
  color: rgba(0, 0, 0, 0.38);
  font-weight: 400;
}
.preview-video-btn--muted .v-icon {
  color: rgba(0, 0, 0, 0.38) !important;
  font-weight: 400;
}
.preview-video-btn--normal .v-icon {
  color: rgba(0, 0, 0, 0.87) !important;
  font-weight: 400;
}
.preview-video-btn--dirty .v-icon {
  color: #1976d2 !important;
  font-weight: 600;
}
.sku-ids-toggle-row {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  margin-top: 4px;
}
.sku-ids-expanded-fields {
  margin-top: 8px;
}
.sku-ids-expanded-fields[aria-hidden="true"] {
  display: none;
}
.active-switch-wrap {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
.active-switch-wrap--dirty >>> .v-input--switch .v-input__slot {
  background-color: rgba(25, 118, 210, 0.08) !important;
  border-radius: 4px;
}
.video-modal-field-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex-wrap: wrap;
}
.video-modal-field-row >>> .v-text-field {
  flex: 1 1 200px;
  min-width: 0;
}
.desc-col-inner {
  min-width: 0;
  max-width: 100%;
}
.sku-expanded-pane {
  min-width: 0;
  max-width: 100%;
  overflow-x: hidden;
}
.sku-expanded-pane >>> .facet-select {
  width: 100%;
  max-width: 100%;
}
.sku-expanded-pane >>> .facet-select .v-input__control {
  max-width: 100%;
}
.sku-expanded-pane >>> .facet-chip-select {
  width: 100%;
  max-width: 100%;
}
.sku-expanded-pane >>> .v-row {
  margin-left: 0;
  margin-right: 0;
}
.sku-expanded-pane >>> .v-col {
  padding-left: 8px;
  padding-right: 8px;
  max-width: 100%;
}
.variants-table tbody tr:last-child td {
  border-bottom: none;
}
.desc-primary {
  color: #1a1a1a;
  font-size: 0.9375rem;
  line-height: 1.35;
  margin: 0 0 6px 0;
}
.sku-ids-block {
  margin: 0;
  padding: 0;
}
.sku-ids-row {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.35rem 0.5rem;
  margin: 0 0 0.4rem 0;
  line-height: 1.45;
}
.sku-ids-row:last-child {
  margin-bottom: 0;
}
.sku-ids-label {
  font-size: 0.8125rem;
  font-weight: 700;
  color: #424242;
  letter-spacing: 0.01em;
  flex-shrink: 0;
}
.sku-ids-value {
  font-size: 1rem;
  font-weight: 600;
  color: #1a1a1a;
  word-break: break-word;
}
.sku-ids-row--compact .sku-ids-label {
  font-size: 0.75rem;
}
.sku-ids-row--compact .sku-ids-value {
  font-size: 0.75rem;
}
.sku-extra-fields {
  margin-top: 10px;
  padding-top: 0;
}
.sku-generated-desc-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 0.75rem;
}
.sku-generated-desc {
  flex: 1;
  min-width: 0;
  margin: 0;
  font-size: 0.9375rem;
  line-height: 1.45;
  color: #1a1a1a;
  font-weight: 600;
  word-break: break-word;
}
.sku-generated-desc-toggle {
  flex-shrink: 0;
}
.sku-facet-row-style-voice {
  margin-top: 10px;
}
/* Single-select facet rows (format, etc.); chip styling lives in FacetChipSelect.vue */
.facet-select >>> .v-select__selections {
  min-height: 36px;
  flex-wrap: wrap;
  max-width: 100%;
  padding-right: 8px;
  box-sizing: border-box;
  min-width: 0;
}
.variants-table thead th.level-col,
.level-cell {
  min-width: 0;
}
.level-cell {
  text-align: left;
  vertical-align: top;
  font-weight: 700;
  font-size: 1.05rem;
  color: #333;
}
.cell-inner {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  min-height: 40px;
  min-width: 0;
  width: 100%;
}
.level-field {
  max-width: 100%;
  width: 100%;
  min-width: 0;
}
.level-cell .cell-inner > * {
  width: 100%;
  min-width: 0;
  max-width: 100%;
}
.level-cell >>> .v-input__control,
.level-cell >>> .v-input__slot,
.level-cell >>> .v-select__slot {
  width: 100% !important;
  min-width: 0 !important;
  max-width: 100% !important;
}
.level-field >>> .v-select__selections {
  flex-wrap: wrap;
  align-items: center;
  min-width: 0;
  max-width: 100%;
}
.level-field >>> .v-select__selections input {
  flex: 0 0 0;
  min-width: 0;
  width: 0;
  padding: 0;
}
.level-field >>> input {
  text-align: left;
  font-weight: 700;
}
.variants-table thead th.price-col,
.price-cell {
  vertical-align: top;
  font-weight: 700;
  font-size: 1rem;
  color: #1a1a1a;
  white-space: nowrap;
  min-width: 76px;
}
.price-field {
  flex: 0 0 auto;
  width: 100px;
}
.price-field >>> .v-input__control {
  max-width: 100px;
}
.price-field >>> input {
  text-align: right;
}
.price-field >>> .v-messages {
  white-space: normal;
}
.variants-table thead th.qty-col,
.qty-cell {
  vertical-align: top;
  min-width: 96px;
}
.qty-cell-inner {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  min-height: 40px;
}
.moq-select {
  max-width: 82px;
  width: 100%;
}
.facet-wrap--invalid >>> fieldset {
  border-color: #c62828 !important;
}
.facet-wrap--invalid >>> .v-input__slot {
  background-color: #ffebee;
}
.facet-hint--invalid {
  color: #c62828;
  margin-top: 4px;
  font-weight: 500;
}
@media (max-width: 600px) {
  .pdp-credit-row {
    grid-template-columns: 1fr;
  }
  .pdp-summary-media {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .pdp-summary-details {
    max-width: 100%;
  }
}
</style>
<template>
  <v-container
    fluid
    class="page pdp-page"
    style="position: relative; min-height: 200px"
  >
    <div v-if="loading" class="text-center py-12">
      <v-progress-circular indeterminate size="64" color="primary" />
    </div>

    <v-alert v-if="loadError" type="error" dismissible @input="loadError = ''">
      {{ loadError }}
    </v-alert>
    <v-alert
      v-else-if="saveError"
      type="error"
      dismissible
      @input="saveError = ''"
    >
      {{ saveError }}
    </v-alert>
    <v-snackbar
      v-model="unpublishSnackbar"
      color="error"
      bottom
      left
      class="unpublish-snackbar"
      :timeout="3000"
      @input="onUnpublishSnackbarInput"
    >
      <span>{{ unpublishBannerError }}</span>
      <template #action="{ attrs }">
        <v-btn text v-bind="attrs" @click="clearUnpublishSnackbar">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-alert v-if="savedNotice" type="success" dense text class="mb-4">
      Your changes were published and will appear on jwpepper.com.
    </v-alert>

    <template v-if="form && !loading">
      <div class="pdp-toolbar-sticky">
        <div class="pdp-toolbar">
          <div v-if="deleteProductEdit">
            <v-btn text color="error" @click="openUnpublishDialog">
              Unpublish
            </v-btn>
          </div>
          <div v-else />
          <div class="pdp-toolbar-actions">
            <v-btn
              color="primary"
              class="mr-2"
              :disabled="!canSave"
              @click="openPublishDialog"
            >
              Save
            </v-btn>
            <v-btn text @click="onCancelClick">Cancel</v-btn>
          </div>
        </div>
      </div>

      <v-alert
        v-if="showRecentModificationBanner"
        type="info"
        dense
        text
        class="recent-mod-banner mb-4"
      >
        Our records show that this product was recently modified. Product edits
        made here can take some time to publish to our website. Thank you for
        your patience. We are actively working to make catalog updates faster.
      </v-alert>

      <!-- Product summary: gallery + details (PDP-style) -->
      <div class="pdp-summary open-sans">
        <div class="pdp-summary-media">
          <div class="pdp-main-media">
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <div class="pdp-main-image-wrap" v-bind="attrs" v-on="on">
                  <img
                    v-if="primarySkuId"
                    :src="primaryCoverUrl"
                    class="pdp-main-image"
                    alt="Cover"
                    loading="eager"
                    @error="onCoverError"
                  />
                  <div
                    v-else
                    class="pdp-main-placeholder body-2 text--secondary"
                  >
                    No cover image
                  </div>
                </div>
              </template>
              <span>{{ previewMediaTooltipText }}</span>
            </v-tooltip>
          </div>
        </div>

        <div class="pdp-summary-details">
          <div class="pdp-title-container">
            <template v-if="ruleForProduct('title').visible">
              <v-text-field
                v-if="ruleForProduct('title').editable"
                v-model="form.title"
                class="pdp-title-field ma-0 pa-0"
                :class="{ 'pdp-input--dirty': isProductFieldDirty('title') }"
                dense
                outlined
                hide-details="auto"
                label="Title"
              />
              <h1 v-else class="pdp-h1">{{ form.title || "Untitled" }}</h1>
            </template>
          </div>

          <template v-if="ruleForProduct('subtitle').visible">
            <v-text-field
              v-if="ruleForProduct('subtitle').editable"
              v-model="form.subtitle"
              class="pdp-subtitle-field ma-0 pa-0"
              :class="{ 'pdp-input--dirty': isProductFieldDirty('subtitle') }"
              dense
              outlined
              hide-details="auto"
              label="Subtitle"
            />
            <h2 v-else-if="form.subtitle" class="pdp-h2">
              {{ form.subtitle }}
            </h2>
          </template>

          <div
            v-if="
              ruleForProduct('composer').visible ||
              ruleForProduct('arranger').visible ||
              ruleForProduct('lyricist').visible ||
              ruleForProduct('artist').visible
            "
            class="pdp-details-container"
          >
            <div
              v-if="
                ruleForProduct('composer').visible ||
                ruleForProduct('arranger').visible
              "
              class="pdp-credit-row"
            >
              <template v-if="ruleForProduct('composer').visible">
                <p
                  v-if="!ruleForProduct('composer').editable && form.composer"
                  class="pdp-spec"
                >
                  {{ form.composer }}
                </p>
                <v-text-field
                  v-else-if="ruleForProduct('composer').editable"
                  v-model="form.composer"
                  class="pdp-spec-field"
                  :class="{
                    'pdp-input--dirty': isProductFieldDirty('composer'),
                  }"
                  dense
                  outlined
                  hide-details="auto"
                  label="Composer"
                  placeholder="Name(s)"
                />
              </template>
              <template v-if="ruleForProduct('arranger').visible">
                <p
                  v-if="!ruleForProduct('arranger').editable && form.arranger"
                  class="pdp-spec"
                >
                  arr. {{ form.arranger }}
                </p>
                <v-text-field
                  v-else-if="ruleForProduct('arranger').editable"
                  v-model="form.arranger"
                  class="pdp-spec-field"
                  :class="{
                    'pdp-input--dirty': isProductFieldDirty('arranger'),
                  }"
                  dense
                  outlined
                  hide-details="auto"
                  label="Arranger"
                  placeholder="Name(s)"
                />
              </template>
            </div>
            <div
              v-if="
                ruleForProduct('lyricist').visible ||
                ruleForProduct('artist').visible
              "
              class="pdp-credit-row"
            >
              <template v-if="ruleForProduct('lyricist').visible">
                <p
                  v-if="!ruleForProduct('lyricist').editable && form.lyricist"
                  class="pdp-spec"
                >
                  {{ form.lyricist }}
                </p>
                <v-text-field
                  v-else-if="ruleForProduct('lyricist').editable"
                  v-model="form.lyricist"
                  class="pdp-spec-field"
                  :class="{
                    'pdp-input--dirty': isProductFieldDirty('lyricist'),
                  }"
                  dense
                  outlined
                  hide-details="auto"
                  label="Lyricist"
                  placeholder="Name(s)"
                />
              </template>
              <template v-if="ruleForProduct('artist').visible">
                <p
                  v-if="!ruleForProduct('artist').editable && form.artist"
                  class="pdp-spec"
                >
                  {{ form.artist }}
                </p>
                <v-text-field
                  v-else-if="ruleForProduct('artist').editable"
                  v-model="form.artist"
                  class="pdp-spec-field"
                  :class="{ 'pdp-input--dirty': isProductFieldDirty('artist') }"
                  dense
                  outlined
                  hide-details="auto"
                  label="Artist"
                  placeholder="Name(s)"
                />
              </template>
            </div>
          </div>

          <div
            v-if="ruleForProduct('description').visible"
            class="pdp-description"
          >
            <v-textarea
              v-if="ruleForProduct('description').editable"
              v-model="form.description"
              class="pdp-description-field"
              :class="{
                'pdp-input--dirty': isProductFieldDirty('description'),
              }"
              label="Description"
              auto-grow
              outlined
              dense
              hide-details="auto"
              rows="4"
              @input="onDescriptionInput"
              @paste.native.prevent="onDescriptionPaste"
            />
            <v-tooltip
              v-else
              :disabled="!form.descriptionLocked"
              bottom
              max-width="320"
            >
              <template #activator="{ on, attrs }">
                <div
                  :class="
                    form.descriptionLocked ? 'pdp-description-locked-wrap' : ''
                  "
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-textarea
                    :value="form.description"
                    class="pdp-description-field"
                    label="Description"
                    outlined
                    dense
                    disabled
                    hide-details="auto"
                    rows="4"
                    auto-grow
                  />
                </div>
              </template>
              <span>{{ descriptionLockedTooltipText }}</span>
            </v-tooltip>
          </div>
        </div>
      </div>

      <!-- Variants table (PLP SKU list style) -->
      <div class="variants-card mb-4">
        <div class="variants-table-scroll">
          <table class="variants-table">
            <colgroup>
              <col class="variants-col-ids" />
              <col class="variants-col-desc" />
              <col class="variants-col-level" />
              <col class="variants-col-preview" />
              <col v-if="showPartsColumn" class="variants-col-parts" />
              <col class="variants-col-price" />
              <col
                v-if="showMinimumOrderQuantityColumn"
                class="variants-col-qty"
              />
              <col v-if="showSkuWebStatusColumn" class="variants-col-active" />
              <col
                v-if="showSkuUnpublishColumn"
                class="variants-col-unpublish"
              />
            </colgroup>
            <thead>
              <tr>
                <th class="ids-col" scope="col"></th>
                <th class="desc-col" scope="col">Description</th>
                <th class="level-col" scope="col">Level</th>
                <th class="preview-col" scope="col">Preview</th>
                <th v-if="showPartsColumn" class="parts-col" scope="col">
                  Parts
                </th>
                <th class="price-col" scope="col">Price</th>
                <th
                  v-if="showMinimumOrderQuantityColumn"
                  class="qty-col"
                  scope="col"
                >
                  Min. Quantity
                </th>
                <th
                  v-if="showSkuWebStatusColumn"
                  class="active-col"
                  scope="col"
                >
                  <v-tooltip bottom max-width="280">
                    <template #activator="{ on, attrs }">
                      <span v-bind="attrs" class="d-inline-block" v-on="on"
                        >Active</span
                      >
                    </template>
                    <span>Inactive SKUs will be hidden from jwpepper.com</span>
                  </v-tooltip>
                </th>
                <th
                  v-if="showSkuUnpublishColumn"
                  class="unpublish-col"
                  scope="col"
                ></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="sku in form.skus"
                :id="`sku-row-${sku.skuId}`"
                :key="sku.skuId"
              >
                <td class="ids-cell">
                  <div class="sku-ids-block open-sans">
                    <div class="sku-ids-row">
                      <span class="sku-ids-label">Pepper ID</span>
                      <span class="sku-ids-value">{{ sku.skuId }}</span>
                    </div>
                    <template v-if="!isIdentifierExpanded(sku)">
                      <div class="sku-ids-row">
                        <span class="sku-ids-label">Supplier ID</span>
                        <span class="sku-ids-value">{{
                          skuSupplierIdDisplay(sku)
                        }}</span>
                      </div>
                      <div class="sku-ids-row sku-ids-row--compact">
                        <span class="sku-ids-label">UPC</span>
                        <span class="sku-ids-value">{{ sku.upc }}</span>
                      </div>
                      <div class="sku-ids-row sku-ids-row--compact">
                        <span class="sku-ids-label">ISBN</span>
                        <span class="sku-ids-value">{{ sku.isbn }}</span>
                      </div>
                      <div class="sku-ids-row sku-ids-row--compact">
                        <span class="sku-ids-label">EAN</span>
                        <span class="sku-ids-value">{{ sku.ean }}</span>
                      </div>
                    </template>
                    <div class="sku-ids-toggle-row">
                      <v-btn
                        v-if="
                          ruleForSku('pubId').editable ||
                          ruleForSku('upc').editable ||
                          ruleForSku('isbn').editable ||
                          ruleForSku('ean').editable
                        "
                        icon
                        small
                        class="sku-ids-toggle-btn mt-0"
                        :aria-label="
                          isIdentifierExpanded(sku)
                            ? 'Done editing product codes'
                            : 'Edit product codes'
                        "
                        @click="toggleIdentifierExpanded(sku)"
                      >
                        <v-icon>{{
                          isIdentifierExpanded(sku) ? "mdi-check" : "mdi-pencil"
                        }}</v-icon>
                      </v-btn>
                    </div>
                    <v-expand-transition>
                      <div
                        v-if="isIdentifierExpanded(sku)"
                        class="sku-ids-expanded-fields"
                      >
                        <v-text-field
                          v-if="ruleForSku('pubId').visible"
                          v-model="sku.pubId"
                          class="mb-2"
                          dense
                          outlined
                          hide-details="auto"
                          label="Supplier ID"
                          :disabled="!ruleForSku('pubId').editable"
                          :error="skuPubIdInvalid(sku)"
                          :error-messages="
                            skuPubIdInvalid(sku)
                              ? ['Supplier ID is required']
                              : []
                          "
                          :class="{
                            'pdp-input--dirty': isSkuFieldDirty(sku, 'pubId'),
                          }"
                        />
                        <v-text-field
                          v-if="ruleForSku('upc').visible"
                          v-model="sku.upc"
                          class="mb-2"
                          dense
                          outlined
                          hide-details="auto"
                          label="UPC"
                          :disabled="!ruleForSku('upc').editable"
                          :class="{
                            'pdp-input--dirty': isSkuFieldDirty(sku, 'upc'),
                          }"
                        />
                        <v-text-field
                          v-if="ruleForSku('isbn').visible"
                          v-model="sku.isbn"
                          class="mb-2"
                          dense
                          outlined
                          hide-details="auto"
                          label="ISBN"
                          :disabled="!ruleForSku('isbn').editable"
                          :class="{
                            'pdp-input--dirty': isSkuFieldDirty(sku, 'isbn'),
                          }"
                        />
                        <v-text-field
                          v-if="ruleForSku('ean').visible"
                          v-model="sku.ean"
                          dense
                          outlined
                          hide-details="auto"
                          label="EAN"
                          :disabled="!ruleForSku('ean').editable"
                          :class="{
                            'pdp-input--dirty': isSkuFieldDirty(sku, 'ean'),
                          }"
                        />
                      </div>
                    </v-expand-transition>
                  </div>
                </td>
                <td class="desc-col">
                  <div class="desc-col-inner">
                    <div class="sku-generated-desc-row">
                      <p class="sku-generated-desc">
                        {{ generatedSkuDescription(sku) }}
                      </p>
                      <v-btn
                        icon
                        small
                        class="sku-generated-desc-toggle mt-0"
                        :aria-label="
                          isSkuExpanded(sku)
                            ? 'Hide composition details'
                            : 'Edit composition details'
                        "
                        @click="toggleSkuExpanded(sku)"
                      >
                        <v-icon>{{
                          isSkuExpanded(sku) ? "mdi-chevron-up" : "mdi-pencil"
                        }}</v-icon>
                      </v-btn>
                    </div>
                    <v-expand-transition>
                      <div
                        v-show="isSkuExpanded(sku)"
                        class="sku-expanded-pane"
                        :aria-hidden="isSkuExpanded(sku) ? 'false' : 'true'"
                      >
                        <div v-if="ruleForSku('productLine').visible">
                          <div class="text-caption text--secondary">
                            Composition Type
                          </div>
                          <v-select
                            v-if="ruleForSku('productLine').editable"
                            :value="sku.productLine.code"
                            :items="productLineSelectItems"
                            item-text="description"
                            item-value="code"
                            dense
                            outlined
                            hide-details
                            class="desc-primary facet-select"
                            @input="onProductLineChange(sku, $event)"
                          />
                          <p v-else class="desc-primary">
                            {{ displayCodedField(sku.productLine) }}
                          </p>
                        </div>
                        <div
                          v-if="hasVisibleSkuDetailFields()"
                          class="sku-extra-fields"
                        >
                          <v-row dense>
                            <v-col
                              v-if="ruleForSku('format').visible"
                              cols="12"
                            >
                              <div class="text-caption text--secondary">
                                Format
                              </div>
                              <div
                                v-if="ruleForSku('format').editable"
                                :class="{
                                  'facet-wrap--invalid': facetFieldInvalid(
                                    sku,
                                    'format',
                                  ),
                                }"
                              >
                                <v-select
                                  :value="sku.format.code"
                                  :items="facetSelectItems(sku, 'formats')"
                                  item-text="description"
                                  item-value="code"
                                  dense
                                  outlined
                                  hide-details
                                  class="facet-select"
                                  :class="{
                                    'pdp-input--dirty': isSkuFieldDirty(
                                      sku,
                                      'format',
                                    ),
                                  }"
                                  @input="onFormatChange(sku, $event)"
                                />
                              </div>
                              <div
                                v-if="
                                  ruleForSku('format').editable &&
                                  facetFieldInvalid(sku, 'format')
                                "
                                class="text-caption facet-hint--invalid"
                              >
                                Selection required
                              </div>
                              <span
                                v-else-if="!ruleForSku('format').editable"
                                class="body-2"
                                >{{ displayCodedField(sku.format) }}</span
                              >
                            </v-col>
                          </v-row>
                          <v-row
                            v-if="
                              ruleForSku('style').visible ||
                              ruleForSku('voicing').visible
                            "
                            dense
                            class="sku-facet-row-style-voice"
                          >
                            <v-col
                              v-if="ruleForSku('voicing').visible"
                              cols="12"
                            >
                              <div class="text-caption text--secondary">
                                Voicing
                              </div>
                              <div
                                v-if="ruleForSku('voicing').editable"
                                :class="{
                                  'facet-wrap--invalid': facetFieldInvalid(
                                    sku,
                                    'voices',
                                  ),
                                }"
                              >
                                <FacetChipSelect
                                  :value="facetCodesSelected(sku, 'voices')"
                                  :items="facetSelectItems(sku, 'voices')"
                                  :show-primary="true"
                                  :primary-code="
                                    facetPrimaryCode(sku, 'voices')
                                  "
                                  :dirty="isSkuFieldDirty(sku, 'voices')"
                                  label="voicing"
                                  @input="
                                    onStyleVoiceCodesChange(
                                      sku,
                                      'voices',
                                      'voices',
                                      $event,
                                    )
                                  "
                                  @remove="
                                    removeFacetCodeFromSelection(
                                      sku,
                                      'voices',
                                      $event,
                                    )
                                  "
                                  @set-primary="
                                    setPrimaryFacetByCode(sku, 'voices', $event)
                                  "
                                />
                              </div>
                              <div
                                v-if="
                                  ruleForSku('voicing').editable &&
                                  facetFieldInvalid(sku, 'voices')
                                "
                                class="text-caption facet-hint--invalid"
                              >
                                Selection required
                              </div>
                              <div
                                v-else-if="!ruleForSku('voicing').editable"
                                class="body-2"
                              >
                                {{ facetRowsReadonlyDisplay(sku.voices) }}
                              </div>
                            </v-col>
                            <v-col v-if="ruleForSku('style').visible" cols="12">
                              <div class="text-caption text--secondary">
                                Style
                              </div>
                              <div
                                v-if="ruleForSku('style').editable"
                                :class="{
                                  'facet-wrap--invalid': facetFieldInvalid(
                                    sku,
                                    'styles',
                                  ),
                                }"
                              >
                                <FacetChipSelect
                                  :value="facetCodesSelected(sku, 'styles')"
                                  :items="facetSelectItems(sku, 'styles')"
                                  :show-primary="true"
                                  :primary-code="
                                    facetPrimaryCode(sku, 'styles')
                                  "
                                  :dirty="isSkuFieldDirty(sku, 'styles')"
                                  label="style"
                                  @input="
                                    onStyleVoiceCodesChange(
                                      sku,
                                      'styles',
                                      'styles',
                                      $event,
                                    )
                                  "
                                  @remove="
                                    removeFacetCodeFromSelection(
                                      sku,
                                      'styles',
                                      $event,
                                    )
                                  "
                                  @set-primary="
                                    setPrimaryFacetByCode(sku, 'styles', $event)
                                  "
                                />
                              </div>
                              <div
                                v-if="
                                  ruleForSku('style').editable &&
                                  facetFieldInvalid(sku, 'styles')
                                "
                                class="text-caption facet-hint--invalid"
                              >
                                Selection required
                              </div>
                              <div
                                v-else-if="!ruleForSku('style').editable"
                                class="body-2"
                              >
                                {{ facetRowsReadonlyDisplay(sku.styles) }}
                              </div>
                            </v-col>
                          </v-row>
                        </div>
                      </div>
                    </v-expand-transition>
                  </div>
                </td>
                <td class="level-cell">
                  <div class="cell-inner">
                    <template v-if="ruleForSku('grade').visible">
                      <div v-if="ruleForSku('grade').editable">
                        <div
                          :class="{
                            'facet-wrap--invalid': facetFieldInvalid(
                              sku,
                              'grades',
                            ),
                          }"
                        >
                          <FacetChipSelect
                            :value="facetCodesSelected(sku, 'grades')"
                            :items="facetSelectItems(sku, 'grades')"
                            :placeholder="gradeAbbrevFromSku(sku)"
                            :dirty="isSkuFieldDirty(sku, 'grades')"
                            select-class="level-field ma-0 pa-0 facet-select"
                            @input="onGradeCodesChange(sku, $event)"
                            @remove="
                              removeFacetCodeFromSelection(
                                sku,
                                'grades',
                                $event,
                              )
                            "
                          />
                        </div>
                        <div
                          v-if="facetFieldInvalid(sku, 'grades')"
                          class="text-caption facet-hint--invalid"
                        >
                          Selection required
                        </div>
                      </div>
                      <span v-else class="body-1">{{
                        gradeAbbrevFromSku(sku)
                      }}</span>
                    </template>
                  </div>
                </td>
                <td class="preview-cell">
                  <div
                    v-if="ruleForSku('youtubeUrl').visible"
                    class="preview-cell-inner"
                  >
                    <v-btn
                      text
                      class="preview-video-btn d-flex flex-column align-center"
                      :class="previewVideoBtnClass(sku)"
                      :aria-label="'Video link for SKU ' + sku.skuId"
                      @click="openYoutubeModal(sku)"
                    >
                      <v-icon size="28">mdi-video</v-icon>
                      <div class="preview-video-label">Video</div>
                    </v-btn>
                  </div>
                </td>
                <td v-if="showPartsColumn" class="parts-cell">
                  <v-btn
                    v-if="hasParts(sku)"
                    small
                    text
                    color="primary"
                    class="view-parts-button"
                    @click="openPartsDialog(sku)"
                  >
                    View Parts
                  </v-btn>
                </td>
                <td class="price-cell">
                  <div class="cell-inner">
                    <template v-if="ruleForSku('listPrice').visible">
                      <v-text-field
                        v-if="ruleForSku('listPrice').editable"
                        v-model="sku.listPriceInput"
                        type="text"
                        inputmode="decimal"
                        autocomplete="off"
                        dense
                        outlined
                        hide-details="auto"
                        prefix="$"
                        :error="skuListPriceBelowMinimum(sku)"
                        :error-messages="
                          skuListPriceBelowMinimum(sku)
                            ? [skuListPriceMinimumMessage(sku)]
                            : []
                        "
                        class="price-field ma-0 pa-0"
                        :class="{
                          'pdp-input--dirty': isSkuFieldDirty(sku, 'listPrice'),
                        }"
                        @input="onListPriceInputChange(sku)"
                        @blur="roundSkuListPriceOnBlur(sku)"
                        @keydown="onListPriceKeydown"
                        @paste.native="onListPricePaste($event, sku)"
                      />
                      <span v-else>{{ formatPrice(sku.listPrice) }}</span>
                    </template>
                  </div>
                </td>
                <td v-if="showMinimumOrderQuantityColumn" class="qty-cell">
                  <div class="qty-cell-inner">
                    <template v-if="ruleForSku('minimumOrderQuantity').visible">
                      <v-select
                        v-if="ruleForSku('minimumOrderQuantity').editable"
                        v-model="sku.minimumOrderQuantity"
                        :items="minimumOrderQuantityOptions"
                        dense
                        outlined
                        hide-details
                        class="moq-select ma-0"
                        :class="{
                          'pdp-input--dirty': isSkuFieldDirty(
                            sku,
                            'minimumOrderQuantity',
                          ),
                        }"
                        :aria-label="'Minimum order quantity for ' + sku.skuId"
                      />
                      <span v-else class="body-2">{{
                        displayMinimumOrderQuantity(sku)
                      }}</span>
                    </template>
                  </div>
                </td>
                <td v-if="showSkuWebStatusColumn" class="active-cell">
                  <div
                    class="active-switch-wrap"
                    :class="{
                      'active-switch-wrap--dirty': isSkuFieldDirty(
                        sku,
                        'webStatus',
                      ),
                    }"
                  >
                    <template v-if="ruleForSku('webStatus').visible">
                      <v-switch
                        v-if="ruleForSku('webStatus').editable"
                        :key="webStatusSwitchKey(sku)"
                        :input-value="skuWebStatusIsActive(sku)"
                        dense
                        hide-details
                        class="ma-0 pa-0"
                        @change="onWebStatusToggle(sku, $event)"
                      />
                      <span v-else class="body-2">{{
                        skuWebStatusIsActive(sku) ? "On" : "Off"
                      }}</span>
                    </template>
                  </div>
                </td>
                <td v-if="showSkuUnpublishColumn" class="unpublish-cell">
                  <v-btn
                    icon
                    small
                    color="error"
                    :aria-label="'Unpublish SKU ' + sku.skuId"
                    :disabled="skuUnpublishSaving"
                    @click="openSkuUnpublishDialog(sku)"
                  >
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="edit-support-footer open-sans">
        <p class="edit-support-footer__title">Need help with something else?</p>
        <p class="edit-support-footer__sub">
          Some updates require assistance from the Pepper team.
        </p>
        <v-btn color="primary" outlined @click="openContactSupport">
          Contact Support
        </v-btn>
      </div>
    </template>

    <v-dialog v-model="facetRequiredDialog" max-width="520">
      <v-card>
        <v-card-title class="headline">Required selections</v-card-title>
        <v-card-text class="pt-4">
          <p class="body-2 mb-2">
            Some composition fields are incomplete. Please fill in the
            highlighted selections before saving.
          </p>
          <ul class="pl-4 mb-0">
            <li
              v-for="(line, idx) in facetRequiredIssues"
              :key="'facet-req-' + idx"
              class="body-2"
            >
              {{ line }}
            </li>
          </ul>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="facetRequiredDialog = false">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="publishDialog" max-width="480" persistent>
      <v-card>
        <v-card-title class="headline">Publish changes?</v-card-title>
        <v-card-text class="pt-4">
          <p
            v-if="willHideProductOnPublish"
            class="body-2 error--text mb-0"
          >
            With this update, this product will no longer appear on jwpepper.com.
          </p>
          <p v-else-if="willRemainHiddenOnPublish" class="body-2 mb-0">
            Changes will be saved, but this product will continue to be hidden
            from jwpepper.com
          </p>
          <p v-else class="body-2 mb-0">
            These changes will be published and will appear on jwpepper.com for
            shoppers.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text :disabled="publishSaving" @click="closePublishDialog"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :loading="publishSaving"
            @click="confirmPublish"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="showPartsColumn"
      v-model="partsDialogOpen"
      max-width="980"
      persistent
    >
      <v-card v-if="selectedPartsSku" class="parts-modal">
        <v-card-title class="parts-modal__header">
          <div>
            <div class="parts-modal__eyebrow">
              Parts for SKU {{ selectedPartsSku.skuId }}
            </div>
            <div class="parts-modal__title">
              {{ generatedSkuDescription(selectedPartsSku) }}
            </div>
          </div>
          <div class="parts-modal__actions">
            <v-btn
              icon
              dark
              :disabled="partsSaving"
              aria-label="Close parts"
              @click="cancelPartsDialog"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <v-card-text class="parts-modal__body">
          <p
            v-if="selectedPartsSku.partsSoldSeparately"
            class="parts-modal__sold-separately"
          >
            Parts Sold Separately
          </p>
          <p class="parts-modal__showing">
            Showing: {{ selectedPart.name || "Unnamed part" }}
          </p>
          <div class="parts-modal__content">
            <div class="parts-modal__preview">
              <img
                :src="selectedPart.imageUrl"
                :alt="selectedPart.name || 'Part image'"
                @error="useDefaultPartImage"
              />
            </div>
            <div class="parts-modal__table-wrap">
              <table class="parts-table">
                <thead>
                  <tr>
                    <th scope="col">Part</th>
                    <th scope="col">Price</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(part, index) in selectedPartsSku.parts"
                    :key="part.id"
                    :class="{
                      'parts-table__row--selected': index === selectedPartIndex,
                    }"
                    role="button"
                    tabindex="0"
                    @click="selectedPartIndex = index"
                    @keydown.enter="selectedPartIndex = index"
                    @keydown.space.prevent="selectedPartIndex = index"
                  >
                    <td>
                      <img
                        :src="part.imageUrl"
                        alt=""
                        class="parts-table__thumbnail"
                        @error="useDefaultPartImage"
                      />
                      <v-text-field
                        v-model="part.name"
                        dense
                        hide-details
                        label="Part name"
                        @click.stop
                      />
                    </td>
                    <td>
                      <v-text-field
                        v-model.number="part.price"
                        type="number"
                        min="0"
                        step="0.01"
                        dense
                        hide-details
                        prefix="$"
                        label="Price"
                        @click.stop
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <p v-if="partsSaveError" class="parts-modal__error">
            {{ partsSaveError }}
          </p>
        </v-card-text>
        <v-card-actions class="parts-modal__footer">
          <v-spacer />
          <v-btn text :disabled="partsSaving" @click="cancelPartsDialog">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            :loading="partsSaving"
            @click="savePartsDialog"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="youtubeDialogOpen"
      max-width="560"
      content-class="youtube-link-dialog"
    >
      <v-card v-if="youtubeModalSku">
        <v-card-title class="d-flex align-center justify-space-between py-3">
          <span class="headline">Video link</span>
          <v-btn icon aria-label="Close" @click="closeYoutubeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-2">
          <div class="video-modal-field-row">
            <v-text-field
              v-model="youtubeModalSku.youtubeUrl"
              outlined
              dense
              hide-details="auto"
              label="YouTube URL"
              placeholder="https://"
              class="ma-0"
              :class="{
                'pdp-input--dirty': isSkuFieldDirty(
                  youtubeModalSku,
                  'youtubeUrl',
                ),
              }"
            />
            <v-btn
              color="primary"
              depressed
              class="mt-1 mt-sm-0"
              :disabled="!canOpenYoutubeUrlInNewTab"
              @click="openYoutubeUrlInNewTab"
            >
              Open
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="unpublishDialog" max-width="520" persistent>
      <v-card class="unpublish-confirm-card">
        <v-card-title class="headline">Unpublish product?</v-card-title>
        <v-card-text class="pt-4">
          <p class="body-2 mb-0">
            You are about to remove this product from your catalog. This is a
            destructive action and cannot be undone. Are you sure you want to
            proceed?
          </p>
          <p v-if="unpublishDialogError" class="body-2 error--text mt-3 mb-0">
            {{ unpublishDialogError }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text :disabled="unpublishSaving" @click="closeUnpublishDialog">
            Cancel
          </v-btn>
          <v-btn
            color="error"
            :loading="unpublishSaving"
            @click="confirmUnpublish"
          >
            Unpublish
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="skuUnpublishDialog" max-width="520" persistent>
      <v-card class="unpublish-confirm-card">
        <v-card-title class="headline">Unpublish SKU?</v-card-title>
        <v-card-text class="pt-4">
          <p class="body-2 mb-0">
            You are about to remove this SKU from your catalog. This is a
            destructive action and cannot be undone. Are you sure you want to
            proceed?
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            :disabled="skuUnpublishSaving"
            @click="closeSkuUnpublishDialog"
          >
            Cancel
          </v-btn>
          <v-btn
            color="error"
            :loading="skuUnpublishSaving"
            @click="confirmSkuUnpublish"
          >
            Unpublish
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import FacetChipSelect from "./FacetChipSelect.vue";
import { SHOW_SKU_PARTS_UI } from "./constants.js";
import {
  DEFAULT_COVER_IMAGE_URL,
  JWP_ASSET_BASE_URL,
  coverUrlFromManifest,
} from "./coverImage.js";
import { generatedSkuDescription as getGeneratedSkuDescription } from "./skuDescription.js";

/** Aligns with BrandProductCodeDescription / BrandProductStyleOrVoice in RequestHelpers + API. */
function ensureCodedField(raw) {
  if (!raw || typeof raw !== "object") {
    return { code: "", description: "" };
  }
  return {
    code: raw.code != null ? String(raw.code) : "",
    description: raw.description != null ? String(raw.description) : "",
  };
}

function ensureStyleVoice(raw) {
  const base = ensureCodedField(raw);
  return {
    code: base.code,
    description: base.description,
    primaryFlag: Boolean(raw && raw.primaryFlag),
  };
}

/** Exactly one primary; if none or many, first row is primary (matches Bridge PUT normalization). */
function normalizeStyleVoicePrimariesInPlace(rows) {
  if (!rows || !rows.length) {
    return;
  }
  const primaryCount = rows.filter((r) => r.primaryFlag).length;
  if (primaryCount === 1) {
    return;
  }
  rows.forEach((r, i) => {
    r.primaryFlag = i === 0;
  });
}

/** Deep snapshot of facet fields for product-line switch memory. */
function cloneFacetSnapshot(sku) {
  return {
    format: { ...ensureCodedField(sku.format) },
    grades: (sku.grades || []).map((g) => ({ ...ensureCodedField(g) })),
    styles: (sku.styles || []).map((s) => ({ ...ensureStyleVoice(s) })),
    voices: (sku.voices || []).map((v) => ({ ...ensureStyleVoice(v) })),
  };
}

function stripHtmlTags(str) {
  if (str == null) return "";
  return String(str).replace(/<[^>]*>/g, "");
}

function skuStringField(v) {
  return v != null ? String(v) : "";
}

/** PRODUCT_MASTER.WEB_STATUS: A = active, M = masked */
function normalizeWebStatus(v) {
  const s = v != null ? String(v).trim().toUpperCase() : "";
  return s === "A" ? "A" : "M";
}

/** GET returns description: { copy, locked }; tolerate legacy string. */
function parseProductDescription(data) {
  const d = data.description;
  if (d && typeof d === "object" && "copy" in d) {
    return {
      text: d.copy != null ? String(d.copy) : "",
      locked: Boolean(d.locked),
    };
  }
  if (typeof d === "string") {
    return { text: d, locked: false };
  }
  return { text: "", locked: false };
}

/** List price as a number with at most two decimal places (cents). */
function normalizeListPriceValue(v) {
  const n = Number(v);
  if (!Number.isFinite(n) || n < 0) return 0;
  return Number(n.toFixed(2));
}

/** Two-decimal string for the price text field (no currency symbol; prefix adds $). */
function formatListPriceInputString(n) {
  return normalizeListPriceValue(n).toFixed(2);
}

const SEPARATE_PART_MIN_LIST_PRICE = 3;
const DEFAULT_MIN_LIST_PRICE = 2;

function skuUsesSeparatePartMinimum(sku) {
  const id =
    sku && sku.skuId != null ? String(sku.skuId).trim().toUpperCase() : "";
  return /[PQ]$/.test(id);
}

/**
 * Parse editable list price text: ".99" -> 0.99, round to nearest cent, non-negative.
 */
function parseListPriceInputString(raw) {
  if (raw == null) return 0;
  let s = String(raw).trim().replace(/\$/g, "");
  s = s.replace(/[^\d.]/g, "");
  const dot = s.indexOf(".");
  if (dot >= 0) {
    s = s.slice(0, dot + 1) + s.slice(dot + 1).replace(/\./g, "");
  }
  s = s.trim();
  if (s === "" || s === ".") return 0;
  if (s.startsWith(".")) s = `0${s}`;
  const n = parseFloat(s);
  if (!Number.isFinite(n) || n < 0) return 0;
  return Math.round(n * 100) / 100;
}

function collapseToOneDecimalPoint(s) {
  const i = String(s).indexOf(".");
  if (i < 0) return String(s);
  return (
    String(s).slice(0, i + 1) +
    String(s)
      .slice(i + 1)
      .replace(/\./g, "")
  );
}

function normalizeSkuFromApi(s) {
  const row = { ...s };
  row.productLine = ensureCodedField(s.productLine);
  row.format = ensureCodedField(s.format);
  row.styles = Array.isArray(s.styles) ? s.styles.map(ensureStyleVoice) : [];
  row.voices = Array.isArray(s.voices) ? s.voices.map(ensureStyleVoice) : [];
  row.grades = Array.isArray(s.grades) ? s.grades.map(ensureCodedField) : [];
  row.listPrice =
    s.listPrice != null && !Number.isNaN(Number(s.listPrice))
      ? normalizeListPriceValue(s.listPrice)
      : 0;
  row.listPriceInput = formatListPriceInputString(row.listPrice);
  const pubRaw =
    s.pubId != null && String(s.pubId).trim() !== ""
      ? String(s.pubId).trim()
      : s.supplierId != null && String(s.supplierId).trim() !== ""
        ? String(s.supplierId).trim()
        : "";
  row.pubId = pubRaw;
  row.upc = skuStringField(s.upc);
  row.isbn = skuStringField(s.isbn);
  row.ean = skuStringField(s.ean);
  row.youtubeUrl = skuStringField(s.youtubeUrl);
  row.webStatus = normalizeWebStatus(s.webStatus);
  return row;
}

export default {
  name: "ProductEditView",
  components: { FacetChipSelect },
  props: {
    productId: { type: String, required: true },
    fieldConfig: { type: Object, required: true },
    loadProductEdit: { type: Function, required: true },
    loadProductCodes: { type: Function, required: true },
    saveProductEdit: { type: Function, required: true },
    saveSkuParts: { type: Function, required: true },
    /** When set, shows Unpublish and calls this with productId (parent may redirect). */
    deleteProductEdit: { type: Function, default: null },
    /** When set, shows per-SKU unpublish controls and calls this with productId + skuId. */
    deleteSkuEdit: { type: Function, default: null },
    cdnBase: {
      type: String,
      default: JWP_ASSET_BASE_URL,
    },
    supportUser: {
      type: Object,
      default: null,
    },
    supportSubjectPrefix: {
      type: String,
      default: "Edit to My Score #",
    },
  },
  data() {
    return {
      loading: false,
      loadError: "",
      saveError: "",
      savedNotice: false,
      form: null,
      productCodes: null,
      snapshot: "",
      publishDialog: false,
      publishSaving: false,
      defaultCover: DEFAULT_COVER_IMAGE_URL,
      brokenCovers: {},
      manifestCoverUrl: DEFAULT_COVER_IMAGE_URL,
      coverFetchGeneration: 0,
      /** Per SKU, per product-line code: saved facet state when leaving a line. */
      facetMemoryBySkuId: {},
      /** Per SKU: whether composition / facet editor is expanded in the variants table */
      expandedSkuIds: {},
      /** Per SKU: UPC / ISBN / EAN editor expanded */
      expandedIdentifierSkuIds: {},
      partsDialogOpen: false,
      selectedPartsSku: null,
      selectedPartIndex: 0,
      partsDialogSnapshot: null,
      partsSaving: false,
      partsSaveError: "",
      youtubeModalSkuId: null,
      unpublishDialog: false,
      unpublishSaving: false,
      unpublishDialogError: "",
      unpublishBannerError: "",
      unpublishSnackbar: false,
      skuUnpublishDialog: false,
      skuUnpublishSaving: false,
      skuUnpublishSkuId: null,
      webStatusToggleResetKey: 0,
      facetRequiredDialog: false,
      facetRequiredIssues: [],
      recentModificationTimestamps: [],
      previewMediaTooltipText: "Cover image",
      descriptionLockedTooltipText:
        "This description has been curated by a Pepper employee. Please contact us about updating.",
    };
  },
  computed: {
    primarySkuId() {
      return this.form && this.form.skus && this.form.skus[0]
        ? this.form.skus[0].skuId
        : "";
    },
    primaryCoverUrl() {
      if (!this.primarySkuId || this.brokenCovers[this.primarySkuId]) {
        return this.defaultCover;
      }
      return this.manifestCoverUrl;
    },
    isDirty() {
      if (!this.form) return false;
      return this.serializeForm(this.form) !== this.snapshot;
    },
    hasFacetValidationIssues() {
      return this.collectFacetValidationIssues().length > 0;
    },
    hasListPriceValidationIssues() {
      return this.collectListPriceValidationIssues().length > 0;
    },
    hasPubIdValidationIssues() {
      return this.collectPubIdValidationIssues().length > 0;
    },
    canSave() {
      return (
        this.isDirty &&
        !this.hasFacetValidationIssues &&
        !this.hasListPriceValidationIssues &&
        !this.hasPubIdValidationIssues
      );
    },
    /** Integers 1–99 for minimum order quantity selector. */
    minimumOrderQuantityOptions() {
      return Array.from({ length: 99 }, (_, i) => i + 1);
    },
    showMinimumOrderQuantityColumn() {
      if (!this.ruleForSku("minimumOrderQuantity").visible) {
        return false;
      }
      const skus = (this.form && this.form.skus) || [];
      return skus.some((sku) => {
        const code =
          sku && sku.productLine && sku.productLine.code != null
            ? String(sku.productLine.code).trim()
            : "";
        return ["C", "HB"].includes(code);
      });
    },
    showSkuUnpublishColumn() {
      return typeof this.deleteSkuEdit === "function";
    },
    showSkuWebStatusColumn() {
      return this.ruleForSku("webStatus").visible;
    },
    isCurrentProductFullyMasked() {
      return this.areSkusFullyMasked(this.form && this.form.skus);
    },
    wasProductFullyMasked() {
      const initial = this.initialComparableFromSnapshot;
      return this.areSkusFullyMasked(initial && initial.skus);
    },
    willHideProductOnPublish() {
      return !this.wasProductFullyMasked && this.isCurrentProductFullyMasked;
    },
    willRemainHiddenOnPublish() {
      return this.wasProductFullyMasked && this.isCurrentProductFullyMasked;
    },
    showPartsColumn() {
      return SHOW_SKU_PARTS_UI;
    },
    activeSkuCount() {
      const skus = (this.form && this.form.skus) || [];
      return skus.filter((sku) => this.skuWebStatusIsActive(sku)).length;
    },
    skuUnpublishDialogSku() {
      if (
        this.skuUnpublishSkuId == null ||
        String(this.skuUnpublishSkuId) === "" ||
        !this.form ||
        !this.form.skus
      ) {
        return null;
      }
      const id = String(this.skuUnpublishSkuId);
      return this.form.skus.find((s) => String(s.skuId) === id) || null;
    },
    initialComparableFromSnapshot() {
      if (!this.snapshot) return null;
      try {
        return JSON.parse(this.snapshot);
      } catch (_) {
        return null;
      }
    },
    showRecentModificationBanner() {
      const futureSlackMs = 5 * 60 * 1000;
      const windowMs = 12 * 60 * 60 * 1000;
      const now = Date.now();
      const list = this.recentModificationTimestamps || [];
      return list.some((raw) => {
        const t = new Date(raw).getTime();
        if (Number.isNaN(t)) return false;
        const age = now - t;
        return age >= -futureSlackMs && age <= windowMs;
      });
    },
    youtubeModalSku() {
      if (
        this.youtubeModalSkuId == null ||
        String(this.youtubeModalSkuId) === "" ||
        !this.form ||
        !this.form.skus
      ) {
        return null;
      }
      const id = String(this.youtubeModalSkuId);
      return this.form.skus.find((s) => String(s.skuId) === id) || null;
    },
    selectedPart() {
      const parts = this.selectedPartsSku?.parts || [];
      return (
        parts[this.selectedPartIndex] ||
        parts[0] || {
          imageUrl: this.defaultCover,
          name: "Part",
        }
      );
    },
    youtubeDialogOpen: {
      get() {
        return (
          this.youtubeModalSkuId != null &&
          String(this.youtubeModalSkuId) !== ""
        );
      },
      set(v) {
        if (!v) {
          this.youtubeModalSkuId = null;
        }
      },
    },
    canOpenYoutubeUrlInNewTab() {
      const s = this.youtubeModalSku;
      if (!s) return false;
      return this.isSafeHttpUrl(String(s.youtubeUrl || "").trim());
    },
    productLineSelectItems() {
      const lines = (this.productCodes && this.productCodes.productLines) || [];
      return lines
        .map((l) => ({
          code: l.code != null ? String(l.code) : "",
          description: l.description != null ? String(l.description) : "",
        }))
        .filter((x) => x.code);
    },
  },
  watch: {
    productId: {
      handler() {
        this.fetchData();
      },
    },
    primarySkuId: {
      immediate: true,
      handler(skuId) {
        this.loadManifestCover(skuId);
      },
    },
  },
  mounted() {
    this.fetchData();
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },
  methods: {
    hasVisibleSkuDetailFields() {
      return (
        this.ruleForSku("format").visible ||
        this.ruleForSku("style").visible ||
        this.ruleForSku("voicing").visible
      );
    },
    isSkuExpanded(sku) {
      if (!sku || sku.skuId == null) {
        return false;
      }
      return Boolean(this.expandedSkuIds[String(sku.skuId)]);
    },
    toggleSkuExpanded(sku) {
      if (!sku || sku.skuId == null) {
        return;
      }
      const id = String(sku.skuId);
      const next = !this.expandedSkuIds[id];
      this.$set(this.expandedSkuIds, id, next);
    },
    isIdentifierExpanded(sku) {
      if (!sku || sku.skuId == null) return false;
      return Boolean(this.expandedIdentifierSkuIds[String(sku.skuId)]);
    },
    toggleIdentifierExpanded(sku) {
      if (!sku || sku.skuId == null) return;
      const id = String(sku.skuId);
      const next = !this.expandedIdentifierSkuIds[id];
      this.$set(this.expandedIdentifierSkuIds, id, next);
    },
    hasParts(sku) {
      return Array.isArray(sku?.parts) && sku.parts.length > 0;
    },
    openPartsDialog(sku) {
      if (!SHOW_SKU_PARTS_UI || !this.hasParts(sku)) return;
      this.selectedPartsSku = sku;
      this.selectedPartIndex = 0;
      this.partsDialogSnapshot = this.cloneParts(sku.parts);
      this.partsSaveError = "";
      this.partsDialogOpen = true;
    },
    openPartsDialogFromRoute() {
      if (!SHOW_SKU_PARTS_UI) return;
      const skuId = this.$route?.query?.partsSku;
      if (!skuId || !this.form?.skus) return;
      const sku = this.form.skus.find(
        (candidate) => String(candidate.skuId) === String(skuId),
      );
      if (sku) this.openPartsDialog(sku);
    },
    closePartsDialog() {
      this.partsDialogOpen = false;
      this.selectedPartsSku = null;
      this.selectedPartIndex = 0;
      this.partsDialogSnapshot = null;
    },
    cancelPartsDialog() {
      if (this.partsSaving) return;
      if (this.selectedPartsSku && this.partsDialogSnapshot) {
        this.$set(
          this.selectedPartsSku,
          "parts",
          this.cloneParts(this.partsDialogSnapshot),
        );
      }
      this.closePartsDialog();
    },
    async savePartsDialog() {
      if (!this.selectedPartsSku || this.partsSaving) return;
      const parts = this.cloneParts(this.selectedPartsSku.parts);
      if (
        parts.some(
          (part) =>
            !Number.isInteger(part.id) ||
            part.id <= 0 ||
            !part.name ||
            !Number.isFinite(part.price) ||
            part.price < 0 ||
            !part.imageUrl,
        )
      ) {
        this.partsSaveError =
          "Each part needs a name and a non-negative price before saving.";
        return;
      }

      this.partsSaving = true;
      this.partsSaveError = "";
      try {
        const response = await this.saveSkuParts(
          this.productId,
          this.selectedPartsSku.skuId,
          parts,
        );
        this.$set(
          this.selectedPartsSku,
          "parts",
          this.cloneParts(response.parts),
        );
        this.closePartsDialog();
      } catch (e) {
        this.partsSaveError =
          (e && e.message) || "Unable to save parts. Please try again.";
      } finally {
        this.partsSaving = false;
      }
    },
    cloneParts(parts) {
      return (parts || []).map((part) => ({
        id: Number(part.id),
        name: part.name != null ? String(part.name).trim() : "",
        price: Number(part.price),
        imageUrl: part.imageUrl != null ? String(part.imageUrl).trim() : "",
      }));
    },
    useDefaultPartImage(event) {
      if (event?.target && event.target.src !== this.defaultCover) {
        event.target.src = this.defaultCover;
      }
    },
    skuWebStatusIsActive(sku) {
      return normalizeWebStatus(sku && sku.webStatus) === "A";
    },
    areSkusFullyMasked(skus) {
      if (!Array.isArray(skus) || skus.length === 0) {
        return false;
      }
      return skus.every((sku) => !this.skuWebStatusIsActive(sku));
    },
    webStatusSwitchKey(sku) {
      const skuId = sku && sku.skuId != null ? String(sku.skuId) : "";
      const status = normalizeWebStatus(sku && sku.webStatus);
      return `${skuId}-${status}-${this.webStatusToggleResetKey}`;
    },
    showUnpublishSnackbar(message) {
      this.unpublishSnackbar = false;
      this.$nextTick(() => {
        this.unpublishBannerError = message;
        this.unpublishSnackbar = true;
      });
    },
    clearUnpublishSnackbar() {
      this.unpublishSnackbar = false;
      this.unpublishBannerError = "";
    },
    onUnpublishSnackbarInput(open) {
      if (!open) {
        this.unpublishBannerError = "";
      }
    },
    showSkuMinimumError(message) {
      this.showUnpublishSnackbar(message);
    },
    onWebStatusToggle(sku, val) {
      if (!sku) return;
      this.clearUnpublishSnackbar();
      this.$set(sku, "webStatus", val ? "A" : "M");
    },
    previewVideoBtnClass(sku) {
      if (this.isSkuFieldDirty(sku, "youtubeUrl")) {
        return "preview-video-btn--dirty";
      }
      if (String(sku.youtubeUrl || "").trim() !== "") {
        return "preview-video-btn--normal";
      }
      return "preview-video-btn--muted";
    },
    openYoutubeModal(sku) {
      if (!sku || sku.skuId == null) return;
      this.youtubeModalSkuId = sku.skuId;
    },
    closeYoutubeModal() {
      this.youtubeModalSkuId = null;
    },
    isSafeHttpUrl(raw) {
      const s = String(raw || "").trim();
      if (!s) return false;
      try {
        const u = new URL(s);
        return u.protocol === "http:" || u.protocol === "https:";
      } catch (_) {
        return false;
      }
    },
    openYoutubeUrlInNewTab() {
      const sku = this.youtubeModalSku;
      if (!sku) return;
      const u = String(sku.youtubeUrl || "").trim();
      if (!this.isSafeHttpUrl(u)) return;
      window.open(u, "_blank", "noopener,noreferrer");
    },
    openUnpublishDialog() {
      this.unpublishDialog = true;
      this.unpublishDialogError = "";
      this.clearUnpublishSnackbar();
    },
    closeUnpublishDialog() {
      if (this.unpublishSaving) return;
      this.unpublishDialog = false;
    },
    async confirmUnpublish() {
      if (!this.deleteProductEdit) return;
      this.unpublishSaving = true;
      this.unpublishDialogError = "";
      try {
        await this.deleteProductEdit(this.productId);
        this.unpublishDialog = false;
      } catch (e) {
        this.unpublishDialogError =
          (e && e.message) || "Unpublish failed. Please try again.";
        this.showUnpublishSnackbar(this.unpublishDialogError);
      } finally {
        this.unpublishSaving = false;
      }
    },
    canUnpublishSku(sku) {
      if (!sku || !this.form || !Array.isArray(this.form.skus)) {
        return false;
      }
      if (this.form.skus.length <= 1) {
        this.showSkuMinimumError(
          "At least one SKU must remain as a part of this product.",
        );
        return false;
      }
      if (this.skuWebStatusIsActive(sku) && this.activeSkuCount <= 1) {
        this.showSkuMinimumError(
          "At least one SKU must remain active in your catalog.",
        );
        return false;
      }
      return true;
    },
    openSkuUnpublishDialog(sku) {
      if (!this.deleteSkuEdit || !this.canUnpublishSku(sku)) return;
      this.skuUnpublishSkuId = sku.skuId;
      this.skuUnpublishDialog = true;
      this.clearUnpublishSnackbar();
    },
    closeSkuUnpublishDialog() {
      if (this.skuUnpublishSaving) return;
      this.skuUnpublishDialog = false;
      this.skuUnpublishSkuId = null;
    },
    removeSkuFromSnapshot(skuId) {
      if (!this.snapshot) {
        this.setSnapshotFromForm();
        return;
      }
      try {
        const parsed = JSON.parse(this.snapshot);
        const id = String(skuId);
        parsed.skus = (parsed.skus || []).filter(
          (sku) => String(sku.skuId) !== id,
        );
        this.snapshot = JSON.stringify(parsed);
      } catch (_) {
        this.setSnapshotFromForm();
      }
    },
    removeSkuFromForm(skuId) {
      if (!this.form || !Array.isArray(this.form.skus)) return;
      const id = String(skuId);
      this.form.skus = this.form.skus.filter((sku) => String(sku.skuId) !== id);
      this.$delete(this.expandedSkuIds, id);
      this.$delete(this.expandedIdentifierSkuIds, id);
      this.$delete(this.facetMemoryBySkuId, id);
      if (String(this.youtubeModalSkuId || "") === id) {
        this.youtubeModalSkuId = null;
      }
      this.removeSkuFromSnapshot(id);
    },
    async confirmSkuUnpublish() {
      const sku = this.skuUnpublishDialogSku;
      if (!this.deleteSkuEdit || !sku || !this.canUnpublishSku(sku)) {
        this.closeSkuUnpublishDialog();
        return;
      }
      const skuId = String(sku.skuId);
      this.skuUnpublishSaving = true;
      this.clearUnpublishSnackbar();
      try {
        await this.deleteSkuEdit(this.productId, skuId);
        this.removeSkuFromForm(skuId);
        this.skuUnpublishDialog = false;
        this.skuUnpublishSkuId = null;
      } catch (e) {
        this.skuUnpublishDialog = false;
        this.skuUnpublishSkuId = null;
        this.showUnpublishSnackbar(
          (e && e.message) || "Unable to unpublish SKU. Please try again.",
        );
      } finally {
        this.skuUnpublishSaving = false;
      }
    },
    generatedSkuDescription(sku) {
      return getGeneratedSkuDescription(sku, this.productCodes);
    },
    /** Bridge `pubId`, or legacy `supplierId` from older payloads. */
    skuSupplierIdDisplay(sku) {
      if (!sku) return "";
      return sku.pubId || "";
    },
    skuPubIdInvalid(sku) {
      if (!sku) return false;
      const rule = this.ruleForSku("pubId");
      if (!rule.visible || !rule.editable) return false;
      return skuStringField(sku.pubId).trim() === "";
    },
    skuPubIdValidationIssueLines(sku) {
      if (!this.skuPubIdInvalid(sku)) {
        return [];
      }
      return [`Pepper ID ${sku.skuId}: Supplier ID is required.`];
    },
    displayCodedField(cf) {
      const x = ensureCodedField(cf);
      if (x.description) return x.description;
      if (x.code) return x.code;
      return "—";
    },
    getLineForSku(sku) {
      const code =
        sku && sku.productLine && sku.productLine.code != null
          ? String(sku.productLine.code).trim()
          : "";
      if (!code) {
        return null;
      }
      const lines = (this.productCodes && this.productCodes.productLines) || [];
      return lines.find((l) => String(l.code).trim() === code) || null;
    },
    facetSelectItems(sku, lineKey) {
      const line = this.getLineForSku(sku);
      if (!line || !line[lineKey]) return [];
      return line[lineKey].map((f) => ({
        code: String(f.code != null ? f.code : ""),
        description: String(f.description != null ? f.description : ""),
      }));
    },
    referenceCodedFieldForSku(sku, lineKey, field) {
      const row = ensureCodedField(field);
      const line = this.getLineForSku(sku);
      if (!line || !line[lineKey]) {
        return row;
      }
      const ref = (line[lineKey] || []).find(
        (x) => String(x.code) === String(row.code),
      );
      return ref ? ensureCodedField(ref) : row;
    },
    referenceStyleVoiceRowsForSku(sku, lineKey, rows) {
      const line = this.getLineForSku(sku);
      return (rows || []).map((raw) => {
        const row = ensureStyleVoice(raw);
        if (!line || !line[lineKey]) {
          return row;
        }
        const ref = (line[lineKey] || []).find(
          (x) => String(x.code) === String(row.code),
        );
        if (!ref) {
          return row;
        }
        return {
          ...ensureStyleVoice(ref),
          primaryFlag: row.primaryFlag,
        };
      });
    },
    /** Order grade rows like `line.grades` from productCodes (chip / payload order). */
    sortGradeRowsByReferenceOrder(sku, grades) {
      const order = this.facetSelectItems(sku, "grades");
      if (!order.length || !grades || !grades.length) {
        return grades || [];
      }
      const rank = new Map();
      order.forEach((item, idx) => {
        rank.set(String(item.code), idx);
      });
      return [...grades].sort((a, b) => {
        const ca = a && a.code != null ? String(a.code) : "";
        const cb = b && b.code != null ? String(b.code) : "";
        const ia = rank.has(ca) ? rank.get(ca) : 9999;
        const ib = rank.has(cb) ? rank.get(cb) : 9999;
        return ia - ib;
      });
    },
    facetCodesSelected(sku, key) {
      return (sku[key] || [])
        .map((r) => (r && r.code != null ? String(r.code) : ""))
        .filter((c) => c.trim() !== "");
    },
    facetRowsReadonlyDisplay(rows) {
      const arr = rows || [];
      if (!arr.length) {
        return "—";
      }
      const t = arr
        .map((r) => String((r && (r.description || r.code)) || "").trim())
        .filter(Boolean)
        .join(", ");
      return t || "—";
    },
    clearSkuFacetsForNewLine(sku) {
      this.$set(sku, "format", { code: "", description: "" });
      this.$set(sku, "grades", []);
      this.$set(sku, "styles", []);
      this.$set(sku, "voices", []);
    },
    /**
     * Restore style/voice rows from a snapshot, keeping codes that still exist
     * on the reference line and preserving primary flags where possible.
     */
    restoreStyleVoiceRowsFromSnapshot(snapshotRows, lineRows) {
      const line = lineRows || [];
      const snap = snapshotRows || [];
      const out = [];
      for (const s of snap) {
        const c = s && s.code != null ? String(s.code) : "";
        if (!c.trim()) {
          continue;
        }
        const ref = line.find((x) => String(x.code) === c);
        if (!ref) {
          continue;
        }
        out.push(
          ensureStyleVoice({
            code: String(ref.code != null ? ref.code : ""),
            description: String(ref.description != null ? ref.description : ""),
            primaryFlag: Boolean(s && s.primaryFlag),
          }),
        );
      }
      normalizeStyleVoicePrimariesInPlace(out);
      return out;
    },
    /**
     * Applies a stored facet snapshot if it still satisfies reference constraints.
     * @returns {boolean} whether the snapshot was applied.
     */
    applyFacetSnapshotIfComplete(sku, snapshot, line) {
      const fmt = ensureCodedField(snapshot.format);
      const fRef = (line.formats || []).find(
        (x) => String(x.code) === String(fmt.code),
      );
      if (!fRef || !String(fmt.code).trim()) {
        return false;
      }

      let grades = (snapshot.grades || [])
        .map(ensureCodedField)
        .filter((g) =>
          (line.grades || []).some((x) => String(x.code) === String(g.code)),
        )
        .map((g) => {
          const ref = line.grades.find(
            (x) => String(x.code) === String(g.code),
          );
          return ref
            ? {
                code: String(ref.code != null ? ref.code : ""),
                description: String(
                  ref.description != null ? ref.description : "",
                ),
              }
            : ensureCodedField(g);
        });
      grades = this.sortGradeRowsByReferenceOrder(sku, grades);
      if (grades.length < 1 || grades.length > 2) {
        return false;
      }

      const styles = this.restoreStyleVoiceRowsFromSnapshot(
        snapshot.styles,
        line.styles,
      );
      if (styles.length < 1 || styles.length > 4) {
        return false;
      }

      const voices = this.restoreStyleVoiceRowsFromSnapshot(
        snapshot.voices,
        line.voices,
      );
      if (voices.length < 1 || voices.length > 4) {
        return false;
      }

      this.$set(sku, "format", {
        code: String(fRef.code != null ? fRef.code : ""),
        description: String(fRef.description != null ? fRef.description : ""),
      });
      this.$set(sku, "grades", grades);
      this.$set(sku, "styles", styles);
      this.$set(sku, "voices", voices);
      return true;
    },
    facetFieldInvalid(sku, part) {
      const line = this.getLineForSku(sku);
      if (!line) return false;
      if (part === "format") {
        const rule = this.ruleForSku("format");
        if (!rule.visible || !rule.editable) return false;
        const c = String(
          sku.format && sku.format.code != null ? sku.format.code : "",
        ).trim();
        return !c || !(line.formats || []).some((f) => String(f.code) === c);
      }
      const cfg = {
        grades: { ruleKey: "grade", lineKey: "grades", min: 1, max: 2 },
        styles: { ruleKey: "style", lineKey: "styles", min: 1, max: 4 },
        voices: { ruleKey: "voicing", lineKey: "voices", min: 1, max: 4 },
      }[part];
      if (!cfg) return false;
      const rule = this.ruleForSku(cfg.ruleKey);
      if (!rule.visible || !rule.editable) return false;
      const rows = sku[part] || [];
      if (rows.length < cfg.min || rows.length > cfg.max) return true;
      return rows.some(
        (r) =>
          !(line[cfg.lineKey] || []).some(
            (x) => String(x.code) === String(r && r.code != null ? r.code : ""),
          ),
      );
    },
    skuFacetValidationIssueLines(sku) {
      const issues = [];
      const label = `Pepper ID ${sku.skuId}`;
      const line = this.getLineForSku(sku);
      if (!line) {
        issues.push(
          `${label}: composition type is missing from the reference list.`,
        );
        return issues;
      }
      const fmtRule = this.ruleForSku("format");
      if (fmtRule.visible && fmtRule.editable) {
        const c = String(
          sku.format && sku.format.code != null ? sku.format.code : "",
        ).trim();
        if (!c || !(line.formats || []).some((f) => String(f.code) === c)) {
          issues.push(
            `${label}: choose a format for «${line.description || line.code}».`,
          );
        }
      }
      const facets = [
        {
          ruleKey: "grade",
          skuKey: "grades",
          lineKey: "grades",
          min: 1,
          max: 2,
          countMsg: "one or two grades",
          validMsg: "one or two valid grades",
        },
        {
          ruleKey: "style",
          skuKey: "styles",
          lineKey: "styles",
          min: 1,
          max: 4,
          countMsg: "1\u20134 styles",
          validMsg: "valid styles for this composition type",
        },
        {
          ruleKey: "voicing",
          skuKey: "voices",
          lineKey: "voices",
          min: 1,
          max: 4,
          countMsg: "1\u20134 voicing options",
          validMsg: "valid voicing for this composition type",
        },
      ];
      for (const f of facets) {
        const rule = this.ruleForSku(f.ruleKey);
        if (!rule.visible || !rule.editable) continue;
        const rows = sku[f.skuKey] || [];
        if (rows.length < f.min || rows.length > f.max) {
          issues.push(`${label}: choose ${f.countMsg}.`);
        } else {
          const bad = rows.some(
            (r) =>
              !(line[f.lineKey] || []).some(
                (x) =>
                  String(x.code) === String(r && r.code != null ? r.code : ""),
              ),
          );
          if (bad) issues.push(`${label}: choose ${f.validMsg}.`);
        }
      }
      return issues;
    },
    collectFacetValidationIssues() {
      if (!this.form || !this.form.skus) {
        return [];
      }
      const issues = [];
      for (const sku of this.form.skus) {
        issues.push(...this.skuFacetValidationIssueLines(sku));
      }
      return issues;
    },
    collectListPriceValidationIssues() {
      if (!this.form || !this.form.skus) {
        return [];
      }
      const issues = [];
      for (const sku of this.form.skus) {
        issues.push(...this.skuListPriceValidationIssueLines(sku));
      }
      return issues;
    },
    collectPubIdValidationIssues() {
      if (!this.form || !this.form.skus) {
        return [];
      }
      const issues = [];
      for (const sku of this.form.skus) {
        issues.push(...this.skuPubIdValidationIssueLines(sku));
      }
      return issues;
    },
    onProductLineChange(sku, newCode) {
      if (newCode == null || String(newCode).trim() === "") {
        return;
      }
      const lines = (this.productCodes && this.productCodes.productLines) || [];
      const line = lines.find(
        (l) => String(l.code).trim() === String(newCode || "").trim(),
      );
      if (!line) {
        return;
      }
      const nextLineCode = String(line.code != null ? line.code : "").trim();
      const oldLineCode =
        sku && sku.productLine && sku.productLine.code != null
          ? String(sku.productLine.code).trim()
          : "";
      if (oldLineCode === nextLineCode) {
        return;
      }

      if (oldLineCode) {
        const sid = String(sku.skuId);
        if (!this.facetMemoryBySkuId[sid]) {
          this.$set(this.facetMemoryBySkuId, sid, {});
        }
        this.$set(
          this.facetMemoryBySkuId[sid],
          oldLineCode,
          cloneFacetSnapshot(sku),
        );
      }

      this.$set(sku, "productLine", {
        code: nextLineCode,
        description: String(line.description != null ? line.description : ""),
      });

      const sid = String(sku.skuId);
      const memRoot = this.facetMemoryBySkuId[sid];
      const stored = memRoot && memRoot[nextLineCode];
      if (stored && this.applyFacetSnapshotIfComplete(sku, stored, line)) {
        return;
      }
      this.clearSkuFacetsForNewLine(sku);
    },
    onFormatChange(sku, code) {
      if (code == null || String(code).trim() === "") {
        return;
      }
      const line = this.getLineForSku(sku);
      if (!line || !line.formats) {
        return;
      }
      const ref = line.formats.find((f) => String(f.code) === String(code));
      if (ref) {
        this.$set(sku, "format", {
          code: String(ref.code != null ? ref.code : ""),
          description: String(ref.description != null ? ref.description : ""),
        });
      }
    },
    onGradeCodesChange(sku, codes) {
      const line = this.getLineForSku(sku);
      if (!line || !line.grades) {
        return;
      }
      const arr = Array.isArray(codes) ? codes.slice(0, 2) : [];
      const rows = arr
        .map((c) => {
          const ref = line.grades.find((g) => String(g.code) === String(c));
          return ref
            ? {
                code: String(ref.code != null ? ref.code : ""),
                description: String(
                  ref.description != null ? ref.description : "",
                ),
              }
            : { code: String(c), description: "" };
        })
        .filter((r) => r.code.trim() !== "");
      this.$set(sku, "grades", this.sortGradeRowsByReferenceOrder(sku, rows));
    },
    onStyleVoiceCodesChange(sku, facetKey, lineKey, codes) {
      const line = this.getLineForSku(sku);
      if (!line || !line[lineKey]) return;
      const previous = sku[facetKey] ? [...sku[facetKey]] : [];
      const prevByCode = new Map(
        previous.map((r) => [String(r.code), ensureStyleVoice(r)]),
      );
      const raw = Array.isArray(codes) ? codes : [];
      const uniq = [...new Set(raw.map((c) => String(c)))].slice(0, 4);
      const rows = uniq.map((c) => {
        const ref = line[lineKey].find((x) => String(x.code) === String(c));
        const base = ref
          ? {
              code: String(ref.code != null ? ref.code : ""),
              description: String(
                ref.description != null ? ref.description : "",
              ),
            }
          : { code: c, description: "" };
        const old = prevByCode.get(String(c));
        let primaryFlag = false;
        if (uniq.length === 1) {
          primaryFlag = true;
        } else if (old && old.primaryFlag) {
          primaryFlag = true;
        }
        return { ...base, primaryFlag };
      });
      normalizeStyleVoicePrimariesInPlace(rows);
      this.$set(sku, facetKey, rows);
    },
    setPrimaryFacetByCode(sku, key, code) {
      const arr = (sku[key] || []).map((r) => ensureStyleVoice(r));
      const i = arr.findIndex((r) => String(r.code) === String(code));
      if (i < 0) return;
      arr.forEach((row, idx) => {
        row.primaryFlag = idx === i;
      });
      this.$set(sku, key, arr);
    },
    facetPrimaryCode(sku, key) {
      const row = (sku[key] || []).find((r) => r.primaryFlag);
      return row ? String(row.code) : "";
    },
    removeFacetCodeFromSelection(sku, key, code) {
      const c = String(code);
      const next = this.facetCodesSelected(sku, key).filter(
        (x) => String(x) !== c,
      );
      if (key === "styles") {
        this.onStyleVoiceCodesChange(sku, "styles", "styles", next);
      } else if (key === "voices") {
        this.onStyleVoiceCodesChange(sku, "voices", "voices", next);
      } else if (key === "grades") {
        if (next.length < 1) {
          return;
        }
        this.onGradeCodesChange(sku, next);
      }
    },
    syncFacetArray(sku, key, lineItems, { max, hasPrimary, normalize }) {
      let rows = (sku[key] || [])
        .map(normalize)
        .filter((r) =>
          (lineItems || []).some((x) => String(x.code) === String(r.code)),
        );
      if (rows.length < 1 && lineItems && lineItems[0]) {
        const first = lineItems[0];
        const row = normalize({
          code: first.code,
          description: first.description,
          ...(hasPrimary ? { primaryFlag: true } : {}),
        });
        rows = [row];
      }
      if (rows.length > max) rows = rows.slice(0, max);
      if (hasPrimary) normalizeStyleVoicePrimariesInPlace(rows);
      this.$set(sku, key, rows);
    },
    syncSkuFacetsToLine(sku, line) {
      const f = ensureCodedField(sku.format);
      const fMatch = (line.formats || []).find(
        (x) => String(x.code) === String(f.code),
      );
      if (fMatch) {
        this.$set(sku, "format", ensureCodedField(fMatch));
      } else if (line.formats && line.formats[0]) {
        this.$set(sku, "format", ensureCodedField(line.formats[0]));
      } else {
        this.$set(sku, "format", { code: "", description: "" });
      }

      this.syncFacetArray(sku, "grades", line.grades, {
        max: 2,
        hasPrimary: false,
        normalize: ensureCodedField,
      });
      let grades = sku.grades;
      grades = this.sortGradeRowsByReferenceOrder(sku, grades);
      this.$set(sku, "grades", grades);

      this.syncFacetArray(sku, "styles", line.styles, {
        max: 4,
        hasPrimary: true,
        normalize: ensureStyleVoice,
      });
      this.syncFacetArray(sku, "voices", line.voices, {
        max: 4,
        hasPrimary: true,
        normalize: ensureStyleVoice,
      });
    },
    gradeAbbrevFromSku(sku) {
      const g = sku.grades || [];
      const first = g[0];
      if (!first) return "—";
      const t = String(first.description || first.code || "").trim();
      if (!t) return "—";
      return t.charAt(0).toUpperCase();
    },
    /**
     * Coerce API values to a valid minimum order qty for the selector (1–99).
     * Missing, null, NaN, or values below 1 default to 1.
     */
    normalizeMinimumOrderQuantity(value) {
      const n = Number(value);
      if (!Number.isFinite(n) || n < 1) return 1;
      return Math.min(99, Math.floor(n));
    },
    displayMinimumOrderQuantity(sku) {
      return this.normalizeMinimumOrderQuantity(sku.minimumOrderQuantity);
    },
    formatPrice(n) {
      const x = Number(n);
      if (Number.isNaN(x)) return "—";
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(x);
    },
    minimumListPriceForSku(sku) {
      if (!sku) {
        return null;
      }
      if (skuUsesSeparatePartMinimum(sku)) {
        return SEPARATE_PART_MIN_LIST_PRICE;
      }
      const line = this.getLineForSku(sku);
      const minimumPrice = Number(line && line.minimumPrice);
      return Number.isFinite(minimumPrice) && minimumPrice > 0
        ? minimumPrice
        : DEFAULT_MIN_LIST_PRICE;
    },
    skuListPriceValueForValidation(sku) {
      if (!sku) {
        return 0;
      }
      if (sku.listPriceInput != null) {
        return parseListPriceInputString(sku.listPriceInput);
      }
      return normalizeListPriceValue(sku.listPrice);
    },
    skuListPriceBelowMinimum(sku) {
      if (!sku) return false;
      const rule = this.ruleForSku("listPrice");
      if (!rule.visible || !rule.editable) return false;
      const min = this.minimumListPriceForSku(sku);
      if (min == null) return false;
      return this.skuListPriceValueForValidation(sku) < min;
    },
    skuListPriceMinimumMessage(sku) {
      const min = this.minimumListPriceForSku(sku);
      return min == null
        ? ""
        : `Price should not be less than ${this.formatPrice(min)}`;
    },
    skuListPriceValidationIssueLines(sku) {
      if (!this.skuListPriceBelowMinimum(sku)) {
        return [];
      }
      const label = `Pepper ID ${sku.skuId}`;
      return [`${label}: ${this.skuListPriceMinimumMessage(sku)}.`];
    },
    onListPriceKeydown(e) {
      const allowed = [
        "Backspace",
        "Delete",
        "Tab",
        "Escape",
        "Enter",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End",
      ];
      if (allowed.includes(e.key)) return;
      if (e.ctrlKey || e.metaKey) return;
      if (/^\d$/.test(e.key)) return;
      if (e.key === ".") {
        const t = e.target;
        const v = t.value != null ? String(t.value) : "";
        const a = t.selectionStart != null ? t.selectionStart : 0;
        const b = t.selectionEnd != null ? t.selectionEnd : 0;
        const kept = v.slice(0, a) + v.slice(b);
        if (kept.includes(".")) {
          e.preventDefault();
        }
        return;
      }
      e.preventDefault();
    },
    onListPricePaste(e, sku) {
      if (!sku) return;
      e.preventDefault();
      let chunk =
        (e.clipboardData && e.clipboardData.getData("text/plain")) || "";
      chunk = String(chunk).replace(/[^\d.]/g, "");
      let cleaned = "";
      let sawDot = false;
      for (let i = 0; i < chunk.length; i += 1) {
        const ch = chunk[i];
        if (ch === ".") {
          if (!sawDot) {
            cleaned += ch;
            sawDot = true;
          }
        } else {
          cleaned += ch;
        }
      }
      const t = e.target;
      const start = t.selectionStart != null ? t.selectionStart : 0;
      const end = t.selectionEnd != null ? t.selectionEnd : 0;
      const v = sku.listPriceInput != null ? String(sku.listPriceInput) : "";
      const next = collapseToOneDecimalPoint(
        v.slice(0, start) + cleaned + v.slice(end),
      );
      this.$set(sku, "listPriceInput", next);
      this.$set(sku, "listPrice", parseListPriceInputString(next));
    },
    onListPriceInputChange(sku) {
      if (!sku) return;
      this.$set(
        sku,
        "listPrice",
        parseListPriceInputString(sku.listPriceInput),
      );
    },
    roundSkuListPriceOnBlur(sku) {
      if (!sku) return;
      const n = parseListPriceInputString(sku.listPriceInput);
      this.$set(sku, "listPrice", n);
      this.$set(sku, "listPriceInput", formatListPriceInputString(n));
    },
    syncAllSkuListPricesFromInput() {
      if (!this.form || !this.form.skus) return;
      for (const sku of this.form.skus) {
        const rule = this.ruleForSku("listPrice");
        if (!rule.visible || !rule.editable) continue;
        const n = parseListPriceInputString(sku.listPriceInput);
        this.$set(sku, "listPrice", n);
        this.$set(sku, "listPriceInput", formatListPriceInputString(n));
      }
    },
    openContactSupport() {
      const fw = typeof window !== "undefined" && window.FreshworksWidget;
      if (typeof fw !== "function") return;
      const u = this.supportUser || {};
      const name = u.fullName != null ? String(u.fullName) : "";
      const email = u.email != null ? String(u.email) : "";
      if (name && email) {
        fw("identify", "ticketForm", { name, email });
      }
      const prefix = this.supportSubjectPrefix || "Edit to My Score #";
      fw("prefill", "ticketForm", {
        subject: prefix + this.productId,
        name: name || undefined,
        email: email || undefined,
        type: "Other",
        custom_fields: {
          cf_pepper_product: this.productId,
        },
      });
      fw("open", "ticketForm");
    },
    onDescriptionInput() {
      if (!this.form) return;
      const stripped = stripHtmlTags(this.form.description);
      if (stripped !== this.form.description) {
        this.form.description = stripped;
      }
    },
    onDescriptionPaste(e) {
      if (!this.form) return;
      const text = stripHtmlTags(
        (e.clipboardData && e.clipboardData.getData("text/plain")) || "",
      );
      const target = e.target;
      if (target && typeof target.selectionStart === "number") {
        const start = target.selectionStart;
        const end = target.selectionEnd;
        const v =
          this.form.description != null ? String(this.form.description) : "";
        const next = v.slice(0, start) + text + v.slice(end);
        this.form.description = stripHtmlTags(next);
        this.$nextTick(() => {
          try {
            const pos = start + text.length;
            target.selectionStart = pos;
            target.selectionEnd = pos;
          } catch (_) {
            /* ignore */
          }
        });
      } else {
        const v =
          this.form.description != null ? String(this.form.description) : "";
        this.form.description = stripHtmlTags(v + text);
      }
    },
    isProductFieldDirty(fieldKey) {
      if (!this.form || !this.initialComparableFromSnapshot) return false;
      const rule = this.ruleForProduct(fieldKey);
      if (!rule.visible || !rule.editable) return false;
      const init = this.initialComparableFromSnapshot;
      const cur =
        this.form[fieldKey] != null ? String(this.form[fieldKey]) : "";
      const ini = init[fieldKey] != null ? String(init[fieldKey]) : "";
      return cur !== ini;
    },
    findInitialSkuRow(skuId) {
      const init = this.initialComparableFromSnapshot;
      if (!init || !init.skus) return null;
      return init.skus.find((s) => String(s.skuId) === String(skuId)) || null;
    },
    isSkuFieldDirty(sku, part) {
      if (!sku || !this.form) return false;
      const ruleByPart = {
        format: "format",
        styles: "style",
        voices: "voicing",
        grades: "grade",
        listPrice: "listPrice",
        minimumOrderQuantity: "minimumOrderQuantity",
        pubId: "pubId",
        upc: "upc",
        isbn: "isbn",
        ean: "ean",
        youtubeUrl: "youtubeUrl",
        webStatus: "webStatus",
      };
      const rk = ruleByPart[part];
      if (rk) {
        const r = this.ruleForSku(rk);
        if (!r.visible || !r.editable) return false;
      }
      const initial = this.findInitialSkuRow(sku.skuId);
      if (!initial) return false;
      const cur = this.serializeSkuRow(sku);
      if (part === "format") {
        return JSON.stringify(cur.format) !== JSON.stringify(initial.format);
      }
      if (part === "styles") {
        return JSON.stringify(cur.styles) !== JSON.stringify(initial.styles);
      }
      if (part === "voices") {
        return JSON.stringify(cur.voices) !== JSON.stringify(initial.voices);
      }
      if (part === "grades") {
        return JSON.stringify(cur.grades) !== JSON.stringify(initial.grades);
      }
      if (part === "listPrice") {
        return Number(cur.listPrice) !== Number(initial.listPrice);
      }
      if (part === "minimumOrderQuantity") {
        return (
          this.normalizeMinimumOrderQuantity(cur.minimumOrderQuantity) !==
          this.normalizeMinimumOrderQuantity(initial.minimumOrderQuantity)
        );
      }
      if (part === "pubId") {
        return (
          skuStringField(cur.pubId).trim() !==
          skuStringField(initial.pubId).trim()
        );
      }
      if (part === "upc") {
        return (
          skuStringField(cur.upc).trim() !== skuStringField(initial.upc).trim()
        );
      }
      if (part === "isbn") {
        return (
          skuStringField(cur.isbn).trim() !==
          skuStringField(initial.isbn).trim()
        );
      }
      if (part === "ean") {
        return (
          skuStringField(cur.ean).trim() !== skuStringField(initial.ean).trim()
        );
      }
      if (part === "youtubeUrl") {
        return (
          skuStringField(cur.youtubeUrl).trim() !==
          skuStringField(initial.youtubeUrl).trim()
        );
      }
      if (part === "webStatus") {
        return (
          normalizeWebStatus(cur.webStatus) !==
          normalizeWebStatus(initial.webStatus)
        );
      }
      return false;
    },
    ruleForProduct(key) {
      const base = this.fieldConfig.product[key] || {
        visible: true,
        editable: true,
      };
      if (key === "description" && this.form && this.form.descriptionLocked) {
        return { visible: base.visible, editable: false };
      }
      return base;
    },
    ruleForSku(key) {
      return (
        this.fieldConfig.sku[key] || {
          visible: true,
          editable: true,
        }
      );
    },
    serializeSkuRow(s) {
      const line = this.getLineForSku(s);
      const productLine = line
        ? ensureCodedField(line)
        : ensureCodedField(s.productLine);
      const styles = this.referenceStyleVoiceRowsForSku(s, "styles", s.styles);
      const voices = this.referenceStyleVoiceRowsForSku(s, "voices", s.voices);
      normalizeStyleVoicePrimariesInPlace(styles);
      normalizeStyleVoicePrimariesInPlace(voices);
      const out = {
        skuId: s.skuId,
        pubId: skuStringField(s.pubId).trim(),
        productLine,
        format: this.referenceCodedFieldForSku(s, "formats", s.format),
        styles,
        voices,
        grades: (s.grades || []).map((g) =>
          this.referenceCodedFieldForSku(s, "grades", g),
        ),
        listPrice: normalizeListPriceValue(s.listPrice),
        minimumOrderQuantity: this.normalizeMinimumOrderQuantity(
          s.minimumOrderQuantity,
        ),
        upc: skuStringField(s.upc).trim(),
        isbn: skuStringField(s.isbn).trim(),
        ean: skuStringField(s.ean).trim(),
        youtubeUrl: skuStringField(s.youtubeUrl).trim(),
        webStatus: normalizeWebStatus(s.webStatus),
      };
      return out;
    },
    async loadManifestCover(skuId) {
      const generation = ++this.coverFetchGeneration;
      this.manifestCoverUrl = this.defaultCover;
      const url = await coverUrlFromManifest(skuId, {
        assetBase: this.cdnBase,
        defaultCover: this.defaultCover,
      });
      if (generation !== this.coverFetchGeneration) {
        return;
      }
      this.manifestCoverUrl = url;
    },
    onCoverError(e) {
      if (this.primarySkuId) {
        this.$set(this.brokenCovers, this.primarySkuId, true);
      }
      if (e.target && e.target.src !== this.defaultCover) {
        e.target.src = this.defaultCover;
      }
    },
    serializeForm(f) {
      const skus = (f.skus || [])
        .map((s) => this.serializeSkuRow(s))
        .sort((a, b) => a.skuId.localeCompare(b.skuId));
      return JSON.stringify({
        title: f.title,
        subtitle: f.subtitle,
        composer: f.composer,
        arranger: f.arranger,
        lyricist: f.lyricist != null ? String(f.lyricist) : "",
        artist: f.artist != null ? String(f.artist) : "",
        description: f.description,
        skus,
      });
    },
    setSnapshotFromForm() {
      this.snapshot = this.serializeForm(this.form);
    },
    async fetchData() {
      this.loading = true;
      this.loadError = "";
      this.savedNotice = false;
      this.brokenCovers = {};
      this.facetMemoryBySkuId = {};
      this.expandedSkuIds = {};
      this.expandedIdentifierSkuIds = {};
      this.partsDialogOpen = false;
      this.selectedPartsSku = null;
      this.selectedPartIndex = 0;
      this.partsDialogSnapshot = null;
      this.partsSaving = false;
      this.partsSaveError = "";
      this.youtubeModalSkuId = null;
      this.unpublishDialog = false;
      this.skuUnpublishDialog = false;
      this.skuUnpublishSkuId = null;
      this.webStatusToggleResetKey = 0;
      this.recentModificationTimestamps = [];
      try {
        const [data, codes] = await Promise.all([
          this.loadProductEdit(this.productId),
          this.loadProductCodes(),
        ]);
        this.productCodes = codes;
        const { text: descText, locked: descLocked } =
          parseProductDescription(data);
        const times = [];
        if (data.modified != null && String(data.modified).trim() !== "") {
          times.push(String(data.modified));
        }
        (data.skus || []).forEach((s) => {
          if (s.modified != null && String(s.modified).trim() !== "") {
            times.push(String(s.modified));
          }
        });
        this.recentModificationTimestamps = times;
        this.form = {
          title: data.title || "",
          subtitle: data.subtitle || "",
          composer: data.composer || "",
          arranger: data.arranger || "",
          lyricist: data.lyricist != null ? String(data.lyricist) : "",
          artist: data.artist != null ? String(data.artist) : "",
          description: stripHtmlTags(descText),
          descriptionLocked: descLocked,
          skus: (data.skus || []).map((s) => {
            const row = normalizeSkuFromApi(s);
            row.minimumOrderQuantity = this.normalizeMinimumOrderQuantity(
              s.minimumOrderQuantity,
            );
            return row;
          }),
        };
        (this.form.skus || []).forEach((sku) => {
          const line = this.getLineForSku(sku);
          if (line) {
            this.syncSkuFacetsToLine(sku, line);
          }
        });
        this.$nextTick(() => {
          this.setSnapshotFromForm();
          this.openPartsDialogFromRoute();
        });
      } catch (e) {
        this.form = null;
        this.productCodes = null;
        this.recentModificationTimestamps = [];
        this.loadError =
          (e && e.message) || "Unable to load product. Please try again.";
      } finally {
        this.loading = false;
      }
    },
    openPublishDialog() {
      if (!this.isDirty) return;
      this.saveError = "";
      const priceIssues = this.collectListPriceValidationIssues();
      if (priceIssues.length) {
        this.saveError = "Please correct the highlighted retail prices.";
        return;
      }
      const pubIdIssues = this.collectPubIdValidationIssues();
      if (pubIdIssues.length) {
        this.saveError = "Please enter a Supplier ID for every SKU.";
        return;
      }
      const issues = this.collectFacetValidationIssues();
      if (issues.length) {
        this.facetRequiredIssues = issues;
        this.facetRequiredDialog = true;
        return;
      }
      this.publishDialog = true;
    },
    closePublishDialog() {
      if (this.publishSaving) return;
      this.publishDialog = false;
    },
    async confirmPublish() {
      this.publishSaving = true;
      this.saveError = "";
      try {
        const priceIssues = this.collectListPriceValidationIssues();
        if (priceIssues.length) {
          this.saveError = "Please correct the highlighted retail prices.";
          this.publishDialog = false;
          return;
        }
        const pubIdIssues = this.collectPubIdValidationIssues();
        if (pubIdIssues.length) {
          this.saveError = "Please enter a Supplier ID for every SKU.";
          this.publishDialog = false;
          return;
        }
        const issues = this.collectFacetValidationIssues();
        if (issues.length) {
          this.facetRequiredIssues = issues;
          this.facetRequiredDialog = true;
          this.publishDialog = false;
          return;
        }
        this.syncAllSkuListPricesFromInput();
        const body = {
          title: this.form.title,
          subtitle: this.form.subtitle,
          composer: this.form.composer,
          arranger: this.form.arranger,
          lyricist:
            this.form.lyricist != null ? String(this.form.lyricist) : "",
          artist: this.form.artist != null ? String(this.form.artist) : "",
          description: stripHtmlTags(this.form.description),
          skus: (this.form.skus || []).map((s) => this.serializeSkuRow(s)),
        };
        await this.saveProductEdit(this.productId, body);
        this.publishDialog = false;
        this.savedNotice = true;
        this.setSnapshotFromForm();
      } catch (e) {
        this.saveError = (e && e.message) || "Save failed. Please try again.";
      } finally {
        this.publishSaving = false;
      }
    },
    onCancelClick() {
      this.$emit("cancel");
    },
    handleBeforeUnload(e) {
      if (!this.isDirty) return;
      e.preventDefault();
      e.returnValue = "";
    },
    handleRouteLeave(next) {
      if (!this.isDirty) {
        next();
        return;
      }
      const ok = window.confirm(
        "You have unsaved changes. Leave and discard them?",
      );
      if (ok) next();
      else next(false);
    },
  },
};
</script>
